import carSearchCardStyles from "./cars/search/car-search-card/car-search-card.module.css";
import carBookingDetailsStyles from "./cars/details/car-booking-details/car-booking-details.module.css";
import carBookingDriverDetailsStyles from "./cars/driver/car-booking-details/car-booking-details.module.css";
import carBookingDetailsPaymentStyles from "./cars/payment/car-booking-details/car-booking-details.module.css";
import carCheckoutPricingCardStyles from "./cars/payment/pricing-card/car-pricing-card.module.css";
import carBookingCardStyles from "./account/reservations/cars/car-booking-card/car-booking-card.module.css";
import carBookingPageStyles from "./account/reservations/cars/car-booking-page/car-booking-page.module.css";
import driverInformationFormStyles from "./cars/driver/driver-form/driver-form.module.css";
import hotelSearchCardStyles from "./hotels/search/hotel-search-card/hotel-search-card.module.css";
import hotelImagesPreviewStyles from "./hotels/details/hotel-images-preview/hotel-images-preview.module.css";
import hotelHeadInformationStyles from "./hotels/details/hotel-head-information/hotel-head-information.module.css";
import hotelDetailsTabsStyles from "./hotels/details/hotel-details-tabs/hotel-details-tabs.module.css";
import hotelDescriptionStyles from "./hotels/details/hotel-information/hotel-description.module.css";
import hotelModalAmenitiesStyles from "./hotels/details/hotel-modal-amenities/hotel-modal-amenities.module.css";
import hotelModalInformationStyles from "./hotels/details/hotel-modal-information/hotel-modal-information.module.css";
import roomSearchCardStyles from "./hotels/search/room-search-card/room-search-card.module.css";
import disclaimerStyles from "./globals/messages/disclaimer.module.css";
import priceStyles from "./globals/price/price.module.css";
import communicationNotificationStyles from "./globals/notification-comunication/notification-comunication.module.css";
import hotelBookingCardStyles from "./account/reservations/hotels/hotel-booking-card/hotel-booking-card.module.css";
import hotelBookingDetailsStyles from "./account/reservations/hotels/hotel-booking-details/hotel-booking-details.module.css";
import purchaseSummaryStyles from "./hotels/purchase/purchase-summary/purchase-summary.module.css";
import purchaseDetailsStyles from "./hotels/purchase/purchase-details/purchase-details.module.css";
import mapStyles from "./hotels/map/map.module.css";
import hotelModalDetailsStyles from "./hotels/details/room-modal-details/room-modal-details.module.css";
import carSearchHeaderSummaryStyles from "./cars/search/car-search-header-summary/car-search-header-summary.module.css";
import stepsCirclesStyles from "./globals/steps-circles/steps-circles.module.css";
import informativeCardStyles from "./globals/informative-card/informative-card.module.css";
import flightSearchHeaderSummaryStyles from "./flights/search/flight-search-header-summary/flight-search-header-summary.module.css";
import hotelSearchHeaderSummaryStyles from "./hotels/search/hotel-search-header-summary/hotel-search-header-summary.module.css";
import backButtonStyles from "./globals/back-button/back-button.module.css";
import lastSearchesStyles from "./home/last-searches/last-searches.module.css";
import pricedRecommendationCardStyles from "./home/priced-recommendation-card/priced-recommendation-card.module.css";
import fallbackMessageStyles from "./globals/fallback-messages/fallback-messages.module.css";
import promoCommunicationStyles from "./globals/promo-communication/promo-communication.module.css";
import mobileBookingsCarouselStyles from "./globals/mobile-bookings-carousel/mobile-bookings-carousel.module.css";
import carsSecurityDepositDisclaimerStyles from "./globals/cars-security-deposit-disclaimer/cars-security-deposit-disclaimer.module.css";
import profileHeaderStyles from "./account/profile/profile-header/profile-header.module.css";
import profileMenuStyles from "./account/profile/profile-menu/profile-menu.module.css";
import profileLogoutStyles from "./account/profile/profile-logout/profile-logout.module.css";
import flightBookingCardStyles from "./account/reservations/flights/flight-booking-card/flight-booking-card.module.css";
import flightBookingDetailsStyles from "./account/reservations/flights/flight-booking-details/flight-booking-details.module.css";
import flightBaggageStyles from "./account/reservations/flights/flight-baggage/flight-baggage.module.css";
import checkboxStyles from "./globals/checkbox/checkbox.module.css";
import paymentCardListStyles from "./globals/payment-card-list/payment-card-list.module.css";
import flightSearchFareDetailsStyles from "./flights/search/flight-search-fare-details/flight-search-fare-details.module.css";
import itineraryFlightInfoStyles from "./flights/itenerary/flight-info/itenerary-flight-info.module.css";
import itineraryResumeStyles from "./flights/itenerary/itenerary-resume/itenerary-resume.module.css";
import itineraryPriceStyles from "./flights/itenerary/itenerary-price/itenerary-price.module.css";
import flightDetailsModalStyles from "./flights/modals/flight-details/flight-details.module.css";
import dividersStyles from "./globals/dividers/dividers.module.css";
import successPageStyles from "./globals/success-page/success-page.module.css";
import sideOverPanelStyles from "./globals/side-over-panel/side-over-panel.module.css";
import formBuilderStyles from "./globals/form-builder/form-builder.module.css";
import flightCardStyles from "./flights/search/flight-card/flight-card.module.css";
import flightCalendarCardStyles from "./flights/search/flight-calendar-card/flight-calendar-card.module.css";
import flightSelectedFlightsHeaderStyles from "./flights/search/flight-selected-flights-header/flight-selected-flights-header.module.css";
import originSelectionMobileStyles from "./views/mobile/origin-selection/origin-selection-view.module.css";
import destinationSelectionMobileStyles from "./views/mobile/destination-selection/destination-selection-view.module.css";
import calendarSelectionMobileStyles from "./views/mobile/calendar-selection/calendar-selection-view.module.css";
import editFlightSelectionMobileStyles from "./views/mobile/edit-flight-selection/edit-flight-selection-view.module.css";
import guestSelectionMobileStyles from "./views/mobile/guest-selection/guest-selection-view.module.css";
import editHotelSelectionMobileStyles from "./views/mobile/edit-hotel-selection/edit-hotel-selection-view.module.css";
import editCarSelectionMobileStyles from "./views/mobile/edit-car-selection/edit-car-selection-view.module.css";
import autocompleteMobileStyles from "./views/mobile/autocomplete/autocomplete.module.css";
import passengerSelectionDesktopStyles from "./views/desktop/passenger-selection/passenger-selection-view.module.css";
import passengerSelectionMobileStyles from "./views/mobile/passenger-selection/passenger-selection-view.module.css";
import flightPurchaseDetailsStyles from "./flights/purchase/purchase-details/purchase-details.module.css";
import creditCardsTableAStyles from "./account/credit-cards/credit-cards-table-a/credit-cards-table-a.module.css";
import modalCreditCardsStyles from "./account/credit-cards/modal-credit-cards/modal-credit-cards.module.css";
import favoritesContainerStyles from "./account/favorites/container/favorites-container.module.css";
import flyerProfileStyles from "./account/favorites/flyer-profile/flyer-profile.module.css";
import frequentFlyerInfoStyles from "./account/favorites/frequent-flyer-info/frequent-flyer-info.module.css";
import travelDocumentsStyles from "./account/favorites/travel-documents/travel-documents.module.css";
import newFavoritePassengerStyles from "./account/favorites/new-favorite-passenger/new-favorite-passenger.module.css";
import newTravelerDocumentStyles from "./account/favorites/new-traveler-document/new-traveler-document.module.css";
import newFrequentFlyerStyles from "./account/favorites/new-frequent-flyer/new-frequent-flyer.module.css";
import productSelectStyles from "./home/product-select/product-select.module.css";
import filtersStyles from "./globals/filters/filters.module.css";
import headerStyles from "./account/header/header.module.css";
import footerInterbankStyles from "./footers/footer-interbank/footer-interbank.module.css";
import carouselStyles from "./home/carousel/carousel.module.css";
import passengerFormStyles from "./flights/passenger/passenger-form.module.css";
import guestFormStyles from "./hotels/guest/guest-form/guest-form.module.css";
import maintenancePageStyles from "./globals/maintenance/maintenance.module.css";
import polygonMaskStyles from "./landing/banner/landing-banner.module.css";
import sectionOneStyles from "./landing/section-one/section-one.module.css";
import sectionTwoStyles from "./landing/section-two/section-two.module.css";
import sectionThreeStyles from "./landing/section-three/section-three.module.css";
import buttonStyles from "./landing/button/landing-button.module.css";
import landingClosedStyles from "./landing/closed/landing-closed.module.css";
import paymentCredictCardSelectStyles from "./globals/payment-credict-card-select/payment-credict-card-select.module.css";
import radioGroupStyles from "./globals/radio-group/radio-group.module.css";
import profileTabsStyles from "./account/profile/profile-tabs/profile-tabs.module.css";
import muscleButtonStyles from "./globals/muscle-button/muscle-button.module.css";
import modalStyles from "./globals/modal/modal.module.css";
import priceSliderStyles from "./globals/price-slider/price-slider.module.css";
import rangeSliderStyles from "./globals/range-slider/range-slider.module.css";
import hotelDetailsGeneralStyles from "./hotels/details/hotel-details-general/hotel-details-general.module.css";
import guestPurchaseSummaryStyles from "./hotels/guest/purchase-summary/purchase-summary.module.css";
import utilityModalStyles from "./globals/utility-modal/utility-modal.module.css";
import locationAutocompleteStyles from "./globals/location-autocomplete/location-autocomplete.module.css";
const classes = {
  home: {
    pricedRecommendationCard: {
      filterButtonBase: pricedRecommendationCardStyles.filterButtonBase,
      filterButtonSelected: pricedRecommendationCardStyles.filterButtonSelected,
      filterButtonUnselected: pricedRecommendationCardStyles.filterButtonUnselected,
      titles: pricedRecommendationCardStyles.titles,
      container: pricedRecommendationCardStyles.container,
      image: pricedRecommendationCardStyles.image,
      tagPercentage: pricedRecommendationCardStyles.tagPercentage,
      tagPercentageIcon: pricedRecommendationCardStyles.tagPercentageIcon,
      tagType: pricedRecommendationCardStyles.tagType,
      tagTypeIcon: pricedRecommendationCardStyles.tagTypeIcon,
      infoTitle: pricedRecommendationCardStyles.infoTitle,
      infoDescription: pricedRecommendationCardStyles.infoDescription,
      infoPoints: pricedRecommendationCardStyles.infoPoints,
      infoCash: pricedRecommendationCardStyles.infoCash,
      infoDisclaimer: pricedRecommendationCardStyles.infoDisclaimer
    },
    lastSearches: {
      title: lastSearchesStyles.title,
      mainContainer: lastSearchesStyles.mainContainer,
      cardsContainer: lastSearchesStyles.cardsContainer,
      card: lastSearchesStyles.card,
      cardTitle: lastSearchesStyles.cardTitle,
      cardDetails: lastSearchesStyles.cardDetails,
      cardIcon: lastSearchesStyles.cardIcon
    },
    productSelect: {
      label: productSelectStyles.label,
      labelSelected: productSelectStyles.labelSelected,
      icon: productSelectStyles.icon,
      iconSelected: productSelectStyles.iconSelected,
      tabContainer: productSelectStyles.tabContainer,
      tabBase: productSelectStyles.tabBase,
      tabSelected: productSelectStyles.tabSelected
    },
    carousel: {
      carouselContainerClassNames: carouselStyles.carouselContainerClassNames,
      carouselBackgroundClassNames: carouselStyles.carouselBackgroundClassNames,
      topRightImageContainerClassNames: carouselStyles.topRightImageContainerClassNames,
      topRightImageClassNames: carouselStyles.topRightImageClassNames,
      secondaryImageClassNames: carouselStyles.secondaryImageClassNames,
      titleTextContainerClassNames: carouselStyles.titleTextContainerClassNames,
      titleImageClassNames: carouselStyles.titleImageClassNames,
      titleTextClassNames: carouselStyles.titleTextClassNames,
      subtitleTextContainerClassNames: carouselStyles.subtitleTextContainerClassNames,
      subtitleTextClassNames: carouselStyles.subtitleTextClassNames,
      actionsContainerClassNames: carouselStyles.actionsContainerClassNames,
      actionButtonClassNames: carouselStyles.actionButtonClassNames,
      actionIconContainerClassNames: carouselStyles.actionIconContainerClassNames,
      actionIconClassNames: carouselStyles.actionIconClassNames,
      /* Chip Wow Class Names */
      chipWowClassNames: carouselStyles.chipWowClassNames,
      /* Top Position Class Names */
      topDefaultPositionClassNames: carouselStyles.topDefaultPositionClassNames,
      topTitleImagePositionClassNames: carouselStyles.topTitleImagePositionClassNames,
      topWowChipPositionClassNames: carouselStyles.topWowChipPositionClassNames
    }
  },
  cars: {
    carSearchCard: {
      cardContainerWeb: carSearchCardStyles.cardContainerWeb,
      cardContainerMobile: carSearchCardStyles.cardContainerMobile,
      carInfoContainerWeb: carSearchCardStyles.carInfoContainerWeb,
      carInfoContainerMobile: carSearchCardStyles.carInfoContainerMobile,
      carRentalInfoContainer: carSearchCardStyles.carRentalInfoContainer,
      carRentalImagesContainer: carSearchCardStyles.carRentalImagesContainer,
      carModelContainer: carSearchCardStyles.carModelContainer,
      carModelButton: carSearchCardStyles.carModelButton,
      carModelSpan: carSearchCardStyles.carModelSpan,
      carImage: carSearchCardStyles.carImage,
      carCompanyImage: carSearchCardStyles.carCompanyImage,
      carCharacteristicsContainer: carSearchCardStyles.carCharacteristicsContainer,
      carCharacteristicsItem: carSearchCardStyles.carCharacteristicsItem,
      carCharacteristicsIconColor: carSearchCardStyles.carCharacteristicsIconColor,
      divider: carSearchCardStyles.divider,
      priceContainer: carSearchCardStyles.priceContainer,
      priceButtonWeb: carSearchCardStyles.priceButtonWeb,
      priceButtonMobile: carSearchCardStyles.priceButtonMobile,
      pricePointsClass: carSearchCardStyles.pricePointsClass,
      priceCashClass: carSearchCardStyles.priceCashClass,
      priceLabelClass: carSearchCardStyles.priceLabelClass
    },
    carBookingDetails: {
      carBookingDetailsHeader: {
        carBookingDetailsHeaderContainer: carBookingDetailsStyles.carBookingDetailsHeaderContainer,
        carBookingDetailsBackButton: carBookingDetailsStyles.carBookingDetailsBackButton,
        carBookingDetailsBackButtonIcon: carBookingDetailsStyles.carBookingDetailsBackButtonIcon,
        carBookingDetailsBackButtonText: carBookingDetailsStyles.carBookingDetailsBackButtonText
      },
      carBookingDetails: {
        container: carBookingDetailsStyles.carBookingDetailsContainer
      },
      carBookingDetailsCarInfo: {
        CarInfoContainer: carBookingDetailsStyles.CarInfoContainer,
        carInfoInnerContainer: carBookingDetailsStyles.carInfoInnerContainer,
        CarInfoImage: carBookingDetailsStyles.CarInfoImage,
        carModelContainer: carBookingDetailsStyles.carModelContainer,
        carModel: carBookingDetailsStyles.carModel,
        carModelSpan: carBookingDetailsStyles.carModelSpan,
        carCompanyImage: carBookingDetailsStyles.carCompanyImage,
        carCharacteristicsContainer: carBookingDetailsStyles.carCharacteristicsContainer,
        carCharacteristicsItem: carBookingDetailsStyles.carCharacteristicsItem
      },
      carBookingDetailsPickupDropoff: {
        carPickupDropoffContainer: carBookingDetailsStyles.carPickupDropoffContainer,
        carPickupDropoffHeader: carBookingDetailsStyles.carPickupDropoffHeader,
        carPickupDropoffInfoRow: carBookingDetailsStyles.carPickupDropoffInfoRow,
        carPickupDropoffIconColor: carBookingDetailsStyles.carPickupDropoffIconColor,
        carPickupDropoffIconSize: carBookingDetailsStyles.carPickupDropoffIconSize
      },
      carBookingDetailsRate: {
        carRateContainer: carBookingDetailsStyles.carRateContainer,
        carRateDetailsTitle: carBookingDetailsStyles.carRateDetailsTitle,
        carRateDetailsList: carBookingDetailsStyles.carRateDetailsList,
        carRateInclusionTitle: carBookingDetailsStyles.carRateInclusionTitle,
        carRateInclusionList: carBookingDetailsStyles.carRateInclusionList,
        carRateToPayContainer: carBookingDetailsStyles.carRateToPayContainer,
        carRateToPayTitle: carBookingDetailsStyles.carRateToPayTitle,
        carRateToPayPoints: carBookingDetailsStyles.carRateToPayPoints,
        carRateToPaySeparator: carBookingDetailsStyles.carRateToPaySeparator,
        carRateToPayCash: carBookingDetailsStyles.carRateToPayCash
      },
      carBookingDetailsPricing: {
        carBookingDetailsPricingContainer: carBookingDetailsStyles.carBookingDetailsPricingContainer,
        carBookingDetailsPricingButton: carBookingDetailsStyles.carBookingDetailsPricingButton,
        carBookingDetailsPricingFooterContainer: carBookingDetailsStyles.carBookingDetailsPricingFooterContainer,
        carBookingDetailsPricingFooterButton: carBookingDetailsStyles.carBookingDetailsPricingFooterButton
      },
      divider: carBookingDetailsStyles.divider,
      feeTitles: carBookingDetailsStyles.feeTitles,
      feePoints: carBookingDetailsStyles.feePoints,
      feePointsIcon: carBookingDetailsStyles.feePointsIcon,
      feeCash: carBookingDetailsStyles.feeCash
    },
    carBookingDriverDetails: {
      carBookingDetailsTitle: carBookingDriverDetailsStyles.carBookingDetailsTitle,
      titleContainerClassName: carBookingDriverDetailsStyles.titleContainerClassName,
      carBookingDetails: {
        container: carBookingDriverDetailsStyles.carBookingDetailsContainer
      },
      carBookingDetailsCarInfo: {
        CarInfoContainer: carBookingDriverDetailsStyles.CarInfoContainer,
        carInfoInnerContainer: carBookingDriverDetailsStyles.carInfoInnerContainer,
        CarInfoImage: carBookingDriverDetailsStyles.CarInfoImage,
        carModelContainer: carBookingDriverDetailsStyles.carModelContainer,
        carModel: carBookingDriverDetailsStyles.carModel,
        carModelSpan: carBookingDriverDetailsStyles.carModelSpan,
        carCompanyImage: carBookingDriverDetailsStyles.carCompanyImage,
        carCharacteristicsContainer: carBookingDriverDetailsStyles.carCharacteristicsContainer,
        carCharacteristicsItem: carBookingDriverDetailsStyles.carCharacteristicsItem
      },
      carBookingDetailsPickupDropoff: {
        carPickupDropoffContainer: carBookingDriverDetailsStyles.carPickupDropoffContainer,
        carPickupDropoffHeader: carBookingDriverDetailsStyles.carPickupDropoffHeader,
        carPickupDropoffInfoRow: carBookingDriverDetailsStyles.carPickupDropoffInfoRow,
        carPickupDropoffIconColor: carBookingDriverDetailsStyles.carPickupDropoffIconColor,
        carPickupDropoffIconSize: carBookingDriverDetailsStyles.carPickupDropoffIconSize
      },
      carBookingDetailsRate: {
        carRateContainer: carBookingDriverDetailsStyles.carRateContainer,
        carRateDetailsTitle: carBookingDriverDetailsStyles.carRateDetailsTitle,
        carRateDetailsList: carBookingDriverDetailsStyles.carRateDetailsList,
        carRateInclusionTitle: carBookingDriverDetailsStyles.carRateInclusionTitle,
        carRateInclusionList: carBookingDriverDetailsStyles.carRateInclusionList,
        carRateToPayContainer: carBookingDriverDetailsStyles.carRateToPayContainer,
        carRateToPayTitle: carBookingDriverDetailsStyles.carRateToPayTitle,
        carRateToPayPoints: carBookingDriverDetailsStyles.carRateToPayPoints,
        carRateToPaySeparator: carBookingDriverDetailsStyles.carRateToPaySeparator,
        carRateToPayCash: carBookingDriverDetailsStyles.carRateToPayCash
      },
      divider: carBookingDriverDetailsStyles.divider
    },
    driverInformationForm: {
      driverFormContainer: driverInformationFormStyles.driverFormContainer,
      driverFormTitle: driverInformationFormStyles.driverFormTitle,
      driverFormInputsContainer: driverInformationFormStyles.driverFormInputsContainer,
      driverFormCheckbox: driverInformationFormStyles.driverFormCheckbox
    },
    carBookingDetailsPayment: {
      carBookingDetails: {
        container: carBookingDetailsPaymentStyles.carBookingDetailsContainer
      },
      carBookingDetailsCarInfo: {
        CarInfoContainer: carBookingDetailsPaymentStyles.CarInfoContainer,
        carInfoInnerContainer: carBookingDetailsPaymentStyles.carInfoInnerContainer,
        CarInfoImage: carBookingDetailsPaymentStyles.CarInfoImage,
        carModelContainer: carBookingDetailsPaymentStyles.carModelContainer,
        carModel: carBookingDetailsPaymentStyles.carModel,
        carModelSpan: carBookingDetailsPaymentStyles.carModelSpan,
        carCompanyImage: carBookingDetailsPaymentStyles.carCompanyImage,
        carCharacteristicsContainer: carBookingDetailsPaymentStyles.carCharacteristicsContainer,
        carCharacteristicsItem: carBookingDetailsPaymentStyles.carCharacteristicsItem
      },
      carBookingDetailsPickupDropoff: {
        carPickupDropoffContainer: carBookingDetailsPaymentStyles.carPickupDropoffContainer,
        carPickupDropoffHeader: carBookingDetailsPaymentStyles.carPickupDropoffHeader,
        carPickupDropoffInfoRow: carBookingDetailsPaymentStyles.carPickupDropoffInfoRow,
        carPickupDropoffIconColor: carBookingDetailsPaymentStyles.carPickupDropoffIconColor,
        carPickupDropoffIconSize: carBookingDetailsPaymentStyles.carPickupDropoffIconSize
      },
      carBookingDetailsRate: {
        carRateContainer: carBookingDetailsPaymentStyles.carRateContainer,
        carRateDetailsTitle: carBookingDetailsPaymentStyles.carRateDetailsTitle,
        carRateDetailsList: carBookingDetailsPaymentStyles.carRateDetailsList,
        carRateInclusionTitle: carBookingDetailsPaymentStyles.carRateInclusionTitle,
        carRateInclusionList: carBookingDetailsPaymentStyles.carRateInclusionList,
        carRateToPayContainer: carBookingDetailsPaymentStyles.carRateToPayContainer,
        carRateToPayTitle: carBookingDetailsPaymentStyles.carRateToPayTitle,
        carRateToPayPoints: carBookingDetailsPaymentStyles.carRateToPayPoints,
        carRateToPaySeparator: carBookingDetailsPaymentStyles.carRateToPaySeparator,
        carRateToPayCash: carBookingDetailsPaymentStyles.carRateToPayCash
      },
      divider: carBookingDetailsPaymentStyles.divider
    },
    checkoutPricingCard: {
      informativeCard: {
        backgroundColor: carCheckoutPricingCardStyles.informativeCard
      }
    },
    carSearchHeaderSummary: {
      infoMainTextClassName: carSearchHeaderSummaryStyles.infoMainTextClassName,
      infoTextClassName: carSearchHeaderSummaryStyles.infoTextClassName,
      infoIconClassName: carSearchHeaderSummaryStyles.infoIconClassName,
      containerClassName: carSearchHeaderSummaryStyles.containerClassName,
      actionsIconClassName: carSearchHeaderSummaryStyles.actionsIconClassName,
      yDivisionLineClassName: carSearchHeaderSummaryStyles.yDivisionLineClassName,
      dotSearchHeaderClassName: carSearchHeaderSummaryStyles.dotSearchHeaderClassName,
      searchDataSummaryTitleClassName: carSearchHeaderSummaryStyles.searchDataSummaryTitleClassName,
      searchDataSummaryTextClassName: carSearchHeaderSummaryStyles.searchDataSummaryTextClassName,
      dotDataSummaryClassName: carSearchHeaderSummaryStyles.dotDataSummaryClassName
    }
  },
  hotels: {
    hotelSearchCard: {
      /*  ---------------- WEB  ---------------- */
      cardContainerWeb: hotelSearchCardStyles.cardContainerWeb,
      cardContentWeb: hotelSearchCardStyles.cardContentWeb,
      cardInfoContainerWeb: hotelSearchCardStyles.cardInfoContainerWeb,
      cardHotelCharacteristicsContainer: hotelSearchCardStyles.cardHotelCharacteristicsContainer,
      cardPriceContainerWeb: hotelSearchCardStyles.cardPriceContainerWeb,
      imageGalleryContainerWeb: hotelSearchCardStyles.imageGalleryContainerWeb,
      imageGalleryWeb: hotelSearchCardStyles.imageGalleryWeb,
      infoHotelNameWeb: hotelSearchCardStyles.infoHotelNameWeb,
      infoHotelAddressWeb: hotelSearchCardStyles.infoHotelAddressWeb,
      /*  ---------------- MOBILE  ---------------- */
      cardContainerMobile: hotelSearchCardStyles.cardContainerMobile,
      cardContentMobile: hotelSearchCardStyles.cardContentMobile,
      cardContentMobileBeforeFix: hotelSearchCardStyles.cardContentMobileBeforeFix,
      cardInfoContainerMobile: hotelSearchCardStyles.cardInfoContainerMobile,
      cardPriceContainerMobile: hotelSearchCardStyles.cardPriceContainerMobile,
      imageGalleryContainerMobile: hotelSearchCardStyles.imageGalleryContainerMobile,
      imageGalleryContainerMobileBeforeFix: hotelSearchCardStyles.imageGalleryContainerMobileBeforeFix,
      imageGalleryMobile: hotelSearchCardStyles.imageGalleryMobile,
      infoHotelNameMobile: hotelSearchCardStyles.infoHotelNameMobile,
      infoHotelAddressMobile: hotelSearchCardStyles.infoHotelAddressMobile,
      /*  ---------------- WEB/MOBILE COMMON  ---------------- */
      imageGalleryArrowsContainer: hotelSearchCardStyles.imageGalleryArrowsContainer,
      imageGalleryArrowsColor: hotelSearchCardStyles.imageGalleryArrowsColor,
      hotelTypeAndRatingContainer: hotelSearchCardStyles.hotelTypeAndRatingContainer,
      hotelTypeAndRatingChipType: hotelSearchCardStyles.hotelTypeAndRatingChipType,
      hotelTypeAndRatingStarsRating: hotelSearchCardStyles.hotelTypeAndRatingStarsRating,
      hotelSearchAmenitiesText: hotelSearchCardStyles.hotelSearchAmenitiesText,
      hotelSearchAmenitiesChip: hotelSearchCardStyles.hotelSearchAmenitiesChip,
      hotelSearchCardAmenitiesIcon: hotelSearchCardStyles.hotelSearchCardAmenitiesIcon,
      hotelPolicyDisclaimerIcon: hotelSearchCardStyles.hotelPolicyDisclaimerIcon,
      hotelPolicyDisclaimerText: hotelSearchCardStyles.hotelPolicyDisclaimerText,
      /*  ---------------- PRICING  ---------------- */
      pricingTitle: hotelSearchCardStyles.pricingTitle,
      pricingCash: hotelSearchCardStyles.pricingCash,
      pricingPoints: hotelSearchCardStyles.pricingPoints,
      princingPerNight: hotelSearchCardStyles.princingPerNight,
      princingPerNightIcon: hotelSearchCardStyles.princingPerNightIcon,
      pricingSelectOfferButton: hotelSearchCardStyles.pricingSelectOfferButton
    },
    hotelDetails: {
      hotelImagesPreview: {
        /*  ---------------- WEB  ---------------- */
        nextBackButtonWeb: hotelImagesPreviewStyles.nextBackButtonWeb,
        carouselContainer: hotelImagesPreviewStyles.carouselContainer,
        carouselContainerActive: hotelImagesPreviewStyles.carouselContainerActive,
        /*  ---------------- MOBILE  ---------------- */
        nextBackButtonMobile: hotelImagesPreviewStyles.nextBackButtonMobile,
        counterMobile: hotelImagesPreviewStyles.counterMobile,
        /*  ---------------- WEB/MOBILE COMMON  ---------------- */
        nextBackButtonDisabled: hotelImagesPreviewStyles.nextBackButtonDisabled
      },
      hotelHeadInformation: {
        /*  ---------------- WEB  ---------------- */
        locationPinIconWeb: hotelHeadInformationStyles.locationPinIconWeb,
        phoneIconWeb: hotelHeadInformationStyles.phoneIconWeb,
        hotelNameWeb: hotelHeadInformationStyles.hotelNameWeb,
        hotelAddressWeb: hotelHeadInformationStyles.hotelAddressWeb,
        hotelPhoneWeb: hotelHeadInformationStyles.hotelPhoneWeb,
        /*  ---------------- MOBILE  ---------------- */
        locationPinIconMobile: hotelHeadInformationStyles.locationPinIconMobile,
        phoneIconMobile: hotelHeadInformationStyles.phoneIconMobile,
        hotelNameMobile: hotelHeadInformationStyles.hotelNameMobile,
        hotelAddressMobile: hotelHeadInformationStyles.hotelAddressMobile,
        hotelPhoneMobile: hotelHeadInformationStyles.hotelPhoneMobile
        /*  ---------------- WEB/MOBILE COMMON  ---------------- */
      },
      hotelDetailsTabs: {
        tabText: hotelDetailsTabsStyles.tabText,
        tabActiveText: hotelDetailsTabsStyles.tabActiveText,
        tabActiveBorder: hotelDetailsTabsStyles.tabActiveBorder
      },
      hotelDescription: {
        descriptionText: hotelDescriptionStyles.descriptionText,
        seeMoreButton: hotelDescriptionStyles.seeMoreButton,
        seeMoreIcon: hotelDescriptionStyles.seeMoreIcon,
        seeMoreInfoText: hotelDescriptionStyles.seeMoreInfoText,
        seeMoreInfoIcon: hotelDescriptionStyles.seeMoreInfoIcon,
        detailsTitle: hotelDescriptionStyles.detailsTitle,
        priorityAmenitiesText: hotelDescriptionStyles.priorityAmenitiesText,
        priorityAmenitiesIcon: hotelDescriptionStyles.priorityAmenitiesIcon,
        priorityAmenitiesSeeMore: hotelDescriptionStyles.priorityAmenitiesSeeMore,
        priorityAmenitiesSeeMoreIcon: hotelDescriptionStyles.priorityAmenitiesSeeMoreIcon,
        hotelPoliciesDisclaimerIcon: hotelDescriptionStyles.hotelPoliciesDisclaimerIcon,
        hotelPoliciesDisclaimerText: hotelDescriptionStyles.hotelPoliciesDisclaimerText
      },
      hotelModalAmenities: {
        modalTitle: hotelModalAmenitiesStyles.modalTitle,
        serviceTitle: hotelModalAmenitiesStyles.serviceTitle,
        serviceTitleIcon: hotelModalAmenitiesStyles.serviceTitleIcon,
        serviceDescription: hotelModalAmenitiesStyles.serviceDescription
      },
      hotelModalInformation: {
        modalTitle: hotelModalInformationStyles.modalTitle,
        modalSubtitle: hotelModalInformationStyles.modalSubtitle,
        modalDescriptionTitle: hotelModalInformationStyles.modalDescriptionTitle,
        modalDescription: hotelModalInformationStyles.modalDescription
      },
      roomModalDetails: {
        roomDetailsTitle: hotelModalDetailsStyles.roomDetailsTitle,
        roomDetailsSubtitles: hotelModalDetailsStyles.roomDetailsSubtitles,
        roomDetailsText: hotelModalDetailsStyles.roomDetailsText,
        roomDetailsIcon: hotelModalDetailsStyles.roomDetailsIcon,
        roomDetailsServicesSeeMore: hotelModalDetailsStyles.roomDetailsServicesSeeMore,
        roomDetailsServicesSeeMoreIcon: hotelModalDetailsStyles.roomDetailsServicesSeeMoreIcon,
        roomDetailsDescriptionIcon: hotelModalDetailsStyles.roomDetailsDescriptionIcon,
        roomDetailTextAmenities: hotelModalDetailsStyles.roomDetailTextAmenities,
        roomDetailTextAmenitiesIcon: hotelModalDetailsStyles.roomDetailTextAmenitiesIcon,
        roomDetailsSeeMorePhotosText: hotelModalDetailsStyles.roomDetailsSeeMorePhotosText,
        roomDetailsSeeMorePhotosIcon: hotelModalDetailsStyles.roomDetailsSeeMorePhotosIcon
      },
      hotelDetailsGeneral: {
        roomsThoughtForYouTitle: hotelDetailsGeneralStyles.roomsThoughtForYouTitle
      }
    },
    roomSearchCard: {
      imageGalleryContainer: roomSearchCardStyles.imageGalleryContainer,
      imageGalleryContainerOffertFix: roomSearchCardStyles.imageGalleryContainerOffertFix,
      imageGallery: roomSearchCardStyles.imageGallery,
      imageGalleryOffertFix: roomSearchCardStyles.imageGalleryOffertFix,
      imageGalleryArrowsContainer: roomSearchCardStyles.imageGalleryArrowsContainer,
      imageGalleryArrowsColor: roomSearchCardStyles.imageGalleryArrowsColor,
      roomName: roomSearchCardStyles.roomName,
      roomBedDescription: roomSearchCardStyles.roomBedDescription,
      roomAmenitiesTitle: roomSearchCardStyles.roomAmenitiesTitle,
      roomAmenitiesText: roomSearchCardStyles.roomAmenitiesText,
      roomAmenitiesCheckIcon: roomSearchCardStyles.roomAmenitiesCheckIcon,
      roomAmenitiesIcon: roomSearchCardStyles.roomAmenitiesIcon,
      roomAmenitiesIncludedIcon: roomSearchCardStyles.roomAmenitiesIncludedIcon,
      roomSeeDetailsText: roomSearchCardStyles.roomSeeDetailsText,
      roomSeeDetailsIcon: roomSearchCardStyles.roomSeeDetailsIcon,
      roomCancelationPoliciesText: roomSearchCardStyles.roomCancelationPoliciesText,
      roomCancelationPoliciesIcon: roomSearchCardStyles.roomCancelationPoliciesIcon,
      roomCancelationPoliciesDisclaimerText: roomSearchCardStyles.roomCancelationPoliciesDisclaimerText,
      roomCancelationPoliciesDisclaimerIcon: roomSearchCardStyles.roomCancelationPoliciesDisclaimerIcon,
      roomTaxesText: roomSearchCardStyles.roomTaxesText,
      roomPriceFareMessage: roomSearchCardStyles.roomPriceFareMessage,
      sliderContainerClass: roomSearchCardStyles.sliderContainerClass,
      priceTitle: roomSearchCardStyles.priceTitle,
      pricingPoints: roomSearchCardStyles.pricingPoints,
      pricingCash: roomSearchCardStyles.pricingCash
    },
    purchase: {
      purchaseSummary: {
        title: purchaseSummaryStyles.title,
        subTitles: purchaseSummaryStyles.subTitles,
        accommodationInfo: purchaseSummaryStyles.accommodationInfo,
        amenitiesInfoIcon: purchaseSummaryStyles.amenitiesInfoIcon,
        documentDisclaimer: purchaseSummaryStyles.documentDisclaimer,
        documentDisclaimerIcon: purchaseSummaryStyles.documentDisclaimerIcon,
        importantPolitics: purchaseSummaryStyles.importantPolitics,
        importantPoliticsIcon: purchaseSummaryStyles.importantPoliticsIcon,
        cancellations: purchaseSummaryStyles.cancellations,
        cancellationsIcon: purchaseSummaryStyles.cancellationsIcon,
        priceTitle: purchaseSummaryStyles.priceTitle,
        priceCombination: purchaseSummaryStyles.priceCombination,
        pricePoints: purchaseSummaryStyles.pricePoints,
        priceCash: purchaseSummaryStyles.priceCash,
        priceBelowTax: purchaseSummaryStyles.priceBelowTax,
        priceBelowTaxValue: purchaseSummaryStyles.priceBelowTaxValue,
        moreInfoBtn: purchaseSummaryStyles.moreInfoBtn,
        moreInfoBtnIcon: purchaseSummaryStyles.moreInfoBtnIcon
      },
      purchaseDetails: {
        container: purchaseDetailsStyles.container,
        imageContainer: purchaseDetailsStyles.imageContainer,
        hotelName: purchaseDetailsStyles.hotelName,
        hotelLocation: purchaseDetailsStyles.hotelLocation,
        hotelTypeChip: purchaseDetailsStyles.hotelTypeChip,
        hotelAmenitiesChip: purchaseDetailsStyles.hotelAmenitiesChip,
        hotelAmenitiesChipIcon: purchaseDetailsStyles.hotelAmenitiesChipIcon,
        summaryTitles: purchaseDetailsStyles.summaryTitles,
        summaryCheckInInfo: purchaseDetailsStyles.summaryCheckInInfo,
        summaryCheckInInfoIcon: purchaseDetailsStyles.summaryCheckInInfoIcon,
        summaryGuestInfo: purchaseDetailsStyles.summaryGuestInfo,
        summaryGuestInfoIcon: purchaseDetailsStyles.summaryGuestInfoIcon,
        summaryRoomInfo: purchaseDetailsStyles.summaryRoomInfo,
        summaryRoomInfoIcon: purchaseDetailsStyles.summaryRoomInfoIcon,
        summaryRoomInfoSeeMore: purchaseDetailsStyles.summaryRoomInfoSeeMore,
        summaryRoomInfoSeeMoreIcon: purchaseDetailsStyles.summaryRoomInfoSeeMoreIcon,
        disclaimers: purchaseDetailsStyles.disclaimers,
        disclaimersIcon: purchaseDetailsStyles.disclaimersIcon,
        informationModalsOpen: purchaseDetailsStyles.informationModalsOpen,
        informationModalsOpenIcon: purchaseDetailsStyles.informationModalsOpenIcon
      }
    },
    map: {
      hotelMapPreviewButton: mapStyles.hotelMapPreviewButton,
      hotelLocationModalTitle: mapStyles.hotelLocationModalTitle,
      hotelMapLocationName: mapStyles.hotelMapLocationName,
      hotelMapLocationIcon: mapStyles.hotelMapLocationIcon
    },
    hotelsSearchHeaderSummary: {
      infoMainTextClassName: hotelSearchHeaderSummaryStyles.infoMainTextClassName,
      infoTextClassName: hotelSearchHeaderSummaryStyles.infoTextClassName,
      infoIconClassName: hotelSearchHeaderSummaryStyles.infoIconClassName,
      containerClassName: hotelSearchHeaderSummaryStyles.containerClassName,
      actionsIconClassName: hotelSearchHeaderSummaryStyles.actionsIconClassName,
      yDivisionLineClassName: hotelSearchHeaderSummaryStyles.yDivisionLineClassName,
      dotSearchHeaderClassName: hotelSearchHeaderSummaryStyles.dotSearchHeaderClassName,
      searchDataSummaryTitleClassName: hotelSearchHeaderSummaryStyles.searchDataSummaryTitleClassName,
      searchDataSummaryTextClassName: hotelSearchHeaderSummaryStyles.searchDataSummaryTextClassName,
      dotDataSummaryClassName: hotelSearchHeaderSummaryStyles.dotDataSummaryClassName
    },
    guestForm: {
      guestFormSectionTitle: guestFormStyles.guestFormSectionTitle,
      guestFormCardTitle: guestFormStyles.guestFormCardTitle,
      checkboxTextClass: guestFormStyles.checkboxTextClass,
      descriptionTextClass: guestFormStyles.descriptionTextClass,
      specialRequestsButtonClass: guestFormStyles.specialRequestsButtonClass,
      specialRequestsButtonIconClass: guestFormStyles.specialRequestsButtonIconClass
    },
    guestPurchaseSummary: {
      container: guestPurchaseSummaryStyles.container,
      imageContainer: guestPurchaseSummaryStyles.imageContainer,
      hotelName: guestPurchaseSummaryStyles.hotelName,
      hotelLocation: guestPurchaseSummaryStyles.hotelLocation,
      hotelTypeChip: guestPurchaseSummaryStyles.hotelTypeChip,
      hotelAmenitiesChip: guestPurchaseSummaryStyles.hotelAmenitiesChip,
      hotelAmenitiesChipIcon: guestPurchaseSummaryStyles.hotelAmenitiesChipIcon,
      summaryTitles: guestPurchaseSummaryStyles.summaryTitles,
      summaryCheckInInfo: guestPurchaseSummaryStyles.summaryCheckInInfo,
      summaryCheckInInfoIcon: guestPurchaseSummaryStyles.summaryCheckInInfoIcon,
      summaryGuestInfo: guestPurchaseSummaryStyles.summaryGuestInfo,
      summaryGuestInfoIcon: guestPurchaseSummaryStyles.summaryGuestInfoIcon,
      summaryRoomInfo: guestPurchaseSummaryStyles.summaryRoomInfo,
      summaryRoomInfoIcon: guestPurchaseSummaryStyles.summaryRoomInfoIcon,
      summaryRoomInfoSeeMore: guestPurchaseSummaryStyles.summaryRoomInfoSeeMore,
      summaryRoomInfoSeeMoreIcon: guestPurchaseSummaryStyles.summaryRoomInfoSeeMoreIcon,
      disclaimers: guestPurchaseSummaryStyles.disclaimers,
      disclaimersIcon: guestPurchaseSummaryStyles.disclaimersIcon,
      informationModalsOpen: guestPurchaseSummaryStyles.informationModalsOpen,
      informationModalsOpenIcon: guestPurchaseSummaryStyles.informationModalsOpenIcon
    }
  },
  globals: {
    disclaimer: {
      backgroundColor: disclaimerStyles.backgroundColor,
      textClassName: disclaimerStyles.textClassName,
      iconClassName: disclaimerStyles.iconClassName
    },
    price: {
      titleCombinationContainer: priceStyles.titleCombinationContainer,
      titleCombinationClassName: priceStyles.titleCombinationClassName,
      paymentMainTitle: priceStyles.paymentMainTitle,
      paymentMainSubtitle: priceStyles.paymentMainSubtitle,
      triplePricingContainer: priceStyles.triplePricingContainer,
      paymentStepsTitle: priceStyles.paymentStepsTitle,
      paymentStepsCircle: priceStyles.paymentStepsCircle,
      paymentStepsCircleText: priceStyles.paymentStepsCircleText,
      paymentActualPointsContainer: priceStyles.paymentActualPointsContainer,
      paymentActualPoints: priceStyles.paymentActualPoints,
      paymentActualPointsEntityIcon: priceStyles.paymentActualPointsEntityIcon,
      paymentActualPointsIcon: priceStyles.paymentActualPointsIcon,
      paymentPointsTitles: priceStyles.paymentPointsTitles,
      paymentPointsToUse: priceStyles.paymentPointsToUse,
      paymentPointsToUseBalance: priceStyles.paymentPointsToUseBalance,
      paymentPriceTitle: priceStyles.paymentPriceTitle,
      paymentPoints: priceStyles.paymentPoints,
      paymentPrice: priceStyles.paymentPrice,
      paymentBelowPriceText: priceStyles.paymentBelowPriceText,
      paymentBelowPriceValue: priceStyles.paymentBelowPriceValue,
      paymentDisclamaimer: priceStyles.paymentDisclamaimer,
      paymentDisclamaimerIcon: priceStyles.paymentDisclamaimerIcon,
      paymentTermsAndConditionsText: priceStyles.paymentTermsAndConditionsText,
      paymentTermsAndConditionsLink: priceStyles.paymentTermsAndConditionsLink,
      beforePriceTitle: priceStyles.beforePriceTitle,
      beforePriceValue: priceStyles.beforePriceValue,
      exchangeForTitle: priceStyles.exchangeForTitle,
      exchangeForValue: priceStyles.exchangeForValue,
      regularPriceTitle: priceStyles.regularPriceTitle,
      regularPriceValue: priceStyles.regularPriceValue,
      providerPriceTitle: priceStyles.providerPriceTitle,
      providerPriceValue: priceStyles.providerPriceValue,
      providerPriceLogo: priceStyles.providerPriceLogo,
      entityLogo: priceStyles.entityLogo,
      continueButton: priceStyles.continueButton,
      seeResumeButton: priceStyles.seeResumeButton,
      paymentButton: priceStyles.paymentButton
    },
    communicationNotification: {
      notificationSuccess: communicationNotificationStyles.notificationSuccess,
      notificationError: communicationNotificationStyles.notificationError,
      notificationInfo: communicationNotificationStyles.notificationInfo,
      notificationWarning: communicationNotificationStyles.notificationWarning
    },
    stepsCircles: {
      selectedLabelClassName: stepsCirclesStyles.selectedLabelClassName,
      unselectedLabelClassName: stepsCirclesStyles.unselectedLabelClassName,
      selectedCircleClassName: stepsCirclesStyles.selectedCircleClassName,
      unselectedCircleClassName: stepsCirclesStyles.unselectedCircleClassName,
      selectedLineConnectorClassName: stepsCirclesStyles.selectedLineConnectorClassName,
      unselectedLineConnectorClassName: stepsCirclesStyles.unselectedLineConnectorClassName
    },
    informativeCard: {
      baseContainer: informativeCardStyles.baseContainer,
      dangerContainer: informativeCardStyles.dangerContainer,
      infoContainer: informativeCardStyles.infoContainer,
      warningContainer: informativeCardStyles.warningContainer,
      dangerText: informativeCardStyles.dangerText,
      infoText: informativeCardStyles.infoText,
      warningText: informativeCardStyles.warningText,
      tooltipInfo: informativeCardStyles.tooltipInfo,
      tooltipWarning: informativeCardStyles.tooltipWarning,
      tooltipDanger: informativeCardStyles.tooltipDanger,
      dangerIcon: informativeCardStyles.dangerIcon,
      infoIcon: informativeCardStyles.infoIcon,
      warningIcon: informativeCardStyles.warningIcon
    },
    backButton: {
      backButtonText: backButtonStyles.backButtonText,
      backButtonIcon: backButtonStyles.backButtonIcon
    },
    fallbackMessage: {
      containerClass: fallbackMessageStyles.containerClass,
      titleClass: fallbackMessageStyles.titleClass,
      descriptionClass: fallbackMessageStyles.descriptionClass,
      imageSearchHotelsClass: fallbackMessageStyles.imageSearchHotelsClass,
      imageSearchCarsClass: fallbackMessageStyles.imageSearchCarsClass,
      imageSearchFlightsClass: fallbackMessageStyles.imageSearchFlightsClass,
      profileEmptyFavoritePassengersImageClass: fallbackMessageStyles.profileEmptyFavoritePassengersImageClass,
      profileEmptyCardsImageClass: fallbackMessageStyles.profileEmptyCardsImageClass,
      profileEmptyFlightsImageClass: fallbackMessageStyles.profileEmptyFlightsImageClass,
      profileEmptyHotelsImageClass: fallbackMessageStyles.profileEmptyHotelsImageClass,
      profileEmptyCarsImageClass: fallbackMessageStyles.profileEmptyCarsImageClass
    },
    promoCommunication: {
      promoBorderColor: promoCommunicationStyles.promoBorderColor,
      promoTextClassName: promoCommunicationStyles.promoTextClassName,
      promoSubTextClassName: promoCommunicationStyles.promoSubTextClassName,
      promoOfferTextClassName: promoCommunicationStyles.promoOfferTextClassName,
      promoChipClassName: promoCommunicationStyles.promoChipClassName,
      offerBorderColor: promoCommunicationStyles.offerBorderColor,
      offerTextClassName: promoCommunicationStyles.offerTextClassName,
      offerSubTextClassName: promoCommunicationStyles.offerSubTextClassName,
      offerOfferTextClassName: promoCommunicationStyles.offerOfferTextClassName,
      offerChipClassName: promoCommunicationStyles.offerChipClassName,
      specialBorderColor: promoCommunicationStyles.specialBorderColor,
      specialTextClassName: promoCommunicationStyles.specialTextClassName,
      specialSubTextClassName: promoCommunicationStyles.specialSubTextClassName,
      specialOfferTextClassName: promoCommunicationStyles.specialOfferTextClassName,
      specialChipClassName: promoCommunicationStyles.specialChipClassName,
      offerWrapperClassName: promoCommunicationStyles.offerWrapperClassName,
      offerBadgeClassName: promoCommunicationStyles.offerBadgeClassName,
      offerContentClassName: promoCommunicationStyles.offerContentClassName,
      specialWrapperClassName: promoCommunicationStyles.specialWrapperClassName,
      specialBadgeClassName: promoCommunicationStyles.specialBadgeClassName,
      specialContentClassName: promoCommunicationStyles.specialContentClassName,
      promoWrapperClassName: promoCommunicationStyles.promoWrapperClassName,
      promoBadgeClassName: promoCommunicationStyles.promoBadgeClassName,
      promoContentClassName: promoCommunicationStyles.promoContentClassName
    },
    mobileBookingsCarousel: {
      container: mobileBookingsCarouselStyles.container,
      navButtonClassName: mobileBookingsCarouselStyles.navButtonClassName,
      paginationTextClassName: mobileBookingsCarouselStyles.paginationTextClassName
    },
    carsSecurityDepositDisclaimer: {
      chipClassName: carsSecurityDepositDisclaimerStyles.chipClassName,
      customTextClassName: carsSecurityDepositDisclaimerStyles.customTextClassName,
      customIconClassName: carsSecurityDepositDisclaimerStyles.customIconClassName
    },
    checkbox: {
      checkboxBase: checkboxStyles.checkboxBase,
      checkboxIcon: checkboxStyles.checkboxIcon,
      checkboxRowClassName: checkboxStyles.checkboxRowClassName,
      checkboxTextClassName: checkboxStyles.checkboxTextClassName,
      checkboxAmountClassName: checkboxStyles.checkboxAmountClassName,
      checkboxDetailsClassName: checkboxStyles.checkboxDetailsClassName
    },
    paymentCardList: {
      cardListContainerClassName: paymentCardListStyles.cardListContainerClassName,
      cardListContainerActiveClassName: paymentCardListStyles.cardListContainerActiveClassName,
      radioButtonClassName: paymentCardListStyles.radioButtonClassName,
      radioButtonActiveClassName: paymentCardListStyles.radioButtonActiveClassName,
      cardListLabelClassNames: paymentCardListStyles.cardListLabelClassNames
    },
    dividers: {
      dividerClassName: dividersStyles.dividerClassName
    },
    successPage: {
      successMainMessageClassName: successPageStyles.successMainMessageClassName,
      mainImageFlightClassName: successPageStyles.mainImageFlightClassName,
      mainImageHotelClassName: successPageStyles.mainImageHotelClassName,
      mainImageCarClassName: successPageStyles.mainImageCarClassName,
      codeContainerClassName: successPageStyles.codeContainerClassName,
      codeTextClassName: successPageStyles.codeTextClassName,
      codeNumberClassName: successPageStyles.codeNumberClassName,
      codeDisclaimerTextClassName: successPageStyles.codeDisclaimerTextClassName,
      detailsOtherMessageClassName: successPageStyles.detailsOtherMessageClassName,
      detailsEmailMessageClassName: successPageStyles.detailsEmailMessageClassName,
      detailsEmailClassName: successPageStyles.detailsEmailClassName,
      recommendationsTitleClassName: successPageStyles.recommendationsTitleClassName,
      recommendationsSubtitleClassName: successPageStyles.recommendationsSubtitleClassName,
      recommendationsTypeContainerClassName: successPageStyles.recommendationsTypeContainerClassName,
      recommendationsTypeTitleClassName: successPageStyles.recommendationsTypeTitleClassName,
      recommendationsTypeCarImageClassName: successPageStyles.recommendationsTypeCarImageClassName,
      recommendationsTypeHotelImageClassName: successPageStyles.recommendationsTypeHotelImageClassName,
      nextStepButtonClassName: successPageStyles.nextStepButtonClassName,
      shareIteneraryTitleClassName: successPageStyles.shareIteneraryTitleClassName,
      shareItenerarySubtitleClassName: successPageStyles.shareItenerarySubtitleClassName,
      shareIteneraryEmailClassName: successPageStyles.shareIteneraryEmailClassName,
      shareIteneraryEmailInputClassName: successPageStyles.shareIteneraryEmailInputClassName,
      shareIteneraryButtonClassName: successPageStyles.shareIteneraryButtonClassName
    },
    sideOverPanel: {
      mainContainer: sideOverPanelStyles.mainContainer,
      titleClassName: sideOverPanelStyles.titleClassName,
      exitIconClassName: sideOverPanelStyles.exitIconClassName,
      backIconClassName: sideOverPanelStyles.backIconClassName,
      clearTextClassName: sideOverPanelStyles.clearTextClassName,
      clearIconClassName: sideOverPanelStyles.clearIconClassName
    },
    formBuilder: {
      inputContainerClassName: formBuilderStyles.inputContainerClassName,
      inputLabelClassName: formBuilderStyles.inputLabelClassName,
      subLabelClassName: formBuilderStyles.subLabelClassName,
      selectedOptionClassName: formBuilderStyles.selectedOptionClassName,
      selectArrowIconClassName: formBuilderStyles.selectArrowIconClassName
    },
    filters: {
      titleClassName: filtersStyles.titleClassName,
      containerClassName: filtersStyles.containerClassName,
      innerContainerClassName: filtersStyles.innerContainerClassName,
      seeMoreButtonClassName: filtersStyles.seeMoreButtonClassName,
      buttonContainerClassName: filtersStyles.buttonContainerClassName,
      buttonTextClassName: filtersStyles.buttonTextClassName,
      checkboxContainerClassName: filtersStyles.checkboxContainerClassName,
      checkboxLabelClassName: filtersStyles.checkboxLabelClassName,
      starRatingColor: filtersStyles.starRatingColor,
      tabContainerClassName: filtersStyles.tabContainerClassName,
      tabSelectedClassName: filtersStyles.tabSelectedClassName,
      tabUnselectedClassName: filtersStyles.tabUnselectedClassName,
      tabSubtitleClassName: filtersStyles.tabSubtitleClassName,
      tabSpecContainerClassName: filtersStyles.tabSpecContainerClassName,
      accordionDividerClassName: filtersStyles.accordionDividerClassName,
      accordionElementContainerClassName: filtersStyles.accordionElementContainerClassName,
      accordionTitleClassName: filtersStyles.accordionTitleClassName,
      clearSelectedFiltersClassName: filtersStyles.clearSelectedFiltersClassName,
      clearSelectedFiltersContainerClassName: filtersStyles.clearSelectedFiltersContainerClassName,
      cleanButtonIconClassName: filtersStyles.cleanButtonIconClassName,
      sortAndFilterContainerClassName: filtersStyles.sortAndFilterContainerClassName,
      sortAndFilterOptionsTextClassName: filtersStyles.sortAndFilterOptionsTextClassName,
      sortAndFilterLabelClassName: filtersStyles.sortAndFilterLabelClassName,
      sortAndFilterSelectedValueClassName: filtersStyles.sortAndFilterSelectedValueClassName,
      sortAndFilterInputTextClassName: filtersStyles.sortAndFilterInputTextClassName,
      sliderTypeATextClassName: filtersStyles.sliderTypeATextClassName,
      expandIconClassName: filtersStyles.expandIconClassName,
      filtersIconClassName: filtersStyles.filtersIconClassName,
      selectOptionClassName: filtersStyles.selectOptionClassName,
      selectSelectedOptionClassName: filtersStyles.selectSelectedOptionClassName
    },
    maintenancePage: {
      containerClassName: maintenancePageStyles.containerClassName,
      titleClassName: maintenancePageStyles.titleClassName,
      descriptionClassName: maintenancePageStyles.descriptionClassName,
      informationContainerClassName: maintenancePageStyles.informationContainerClassName,
      informationItemClassName: maintenancePageStyles.informationItemClassName,
      contactItemsContainerClassName: maintenancePageStyles.contactItemsContainerClassName,
      contactItemClassName: maintenancePageStyles.contactItemClassName,
      contactItemTextClassName: maintenancePageStyles.contactItemTextClassName,
      contactItemIconClassName: maintenancePageStyles.contactItemIconClassName,
      imageContainerClassName: maintenancePageStyles.imageContainerClassName
    },
    paymentCredictCardSelect: {
      containerClassName: paymentCredictCardSelectStyles.containerClassName,
      cardFlagClassName: paymentCredictCardSelectStyles.cardFlagClassName,
      cardFlagDefaultClassName: paymentCredictCardSelectStyles.cardFlagDefaultClassName,
      cardNumberClassName: paymentCredictCardSelectStyles.cardNumberClassName,
      cardNumberSelectedClassName: paymentCredictCardSelectStyles.cardNumberSelectedClassName
    },
    radioGroup: {
      radioButtonBaseClassName: radioGroupStyles.radioButtonBaseClassName,
      radioButtonIndicatorClassName: radioGroupStyles.radioButtonIndicatorClassName,
      radioButtonLabelClassName: radioGroupStyles.radioButtonLabelClassName
    },
    muscleButton: {
      solidXs: muscleButtonStyles.solidXs,
      outlineXs: muscleButtonStyles.outlineXs,
      ghostXs: muscleButtonStyles.ghostXs,
      solidSm: muscleButtonStyles.solidSm,
      outlineSm: muscleButtonStyles.outlineSm,
      ghostSm: muscleButtonStyles.ghostSm,
      solidMd: muscleButtonStyles.solidMd,
      outlineMd: muscleButtonStyles.outlineMd,
      ghostMd: muscleButtonStyles.ghostMd,
      solidLg: muscleButtonStyles.solidLg,
      outlineLg: muscleButtonStyles.outlineLg,
      ghostLg: muscleButtonStyles.ghostLg,
      solidXL: muscleButtonStyles.solidXL,
      outlineXL: muscleButtonStyles.outlineXL,
      ghostXL: muscleButtonStyles.ghostXL,
      link: muscleButtonStyles.link,
      tag: muscleButtonStyles.tag,
      disabled: muscleButtonStyles.disabled
    },
    modal: {
      modalContainer: modalStyles.modalContainer,
      modalTitle: modalStyles.modalTitle,
      modalDescription: modalStyles.modalDescription,
      modalXButton: modalStyles.modalXButton
    },
    priceSlider: {
      rootClassName: priceSliderStyles.rootClassName,
      trackClassName: priceSliderStyles.trackClassName,
      rangeClassName: priceSliderStyles.rangeClassName,
      thumbClassName: priceSliderStyles.thumbClassName,
      thumbIconClassName: priceSliderStyles.thumbIconClassName
    },
    rangeSlider: {
      trackClassName: rangeSliderStyles.trackClassName,
      rangeClassName: rangeSliderStyles.rangeClassName,
      thumbClassName: rangeSliderStyles.thumbClassName,
      valuesClassName: rangeSliderStyles.valuesClassName
    },
    utilityModal: {
      titleClassName: utilityModalStyles.titleClassName,
      titleOfferClassName: utilityModalStyles.titleOfferClassName,
      descriptionClassName: utilityModalStyles.descriptionClassName,
      descriptionOfferClassName: utilityModalStyles.descriptionOfferClassName,
      linkClassName: utilityModalStyles.linkClassName,
      chipWowClassName: utilityModalStyles.chipWowClassName
    },
    locationAutocomplete: {
      containerClassName: locationAutocompleteStyles.containerClassName,
      locationPinIconClassName: locationAutocompleteStyles.locationPinIconClassName,
      flightIconClassName: locationAutocompleteStyles.flightIconClassName,
      headerContainerClassName: locationAutocompleteStyles.headerContainerClassName,
      headerTitleClassName: locationAutocompleteStyles.headerTitleClassName,
      headerSubtitleClassName: locationAutocompleteStyles.headerSubtitleClassName,
      optionContainerClassName: locationAutocompleteStyles.optionContainerClassName,
      optionTitleClassName: locationAutocompleteStyles.optionTitleClassName,
      optionSubtitleClassName: locationAutocompleteStyles.optionSubtitleClassName
    }
  },
  account: {
    header: {
      headerEntityContainerLogoClassNames: headerStyles.headerEntityContainerLogoClassNames,
      headerEntityLogoDesktopClassNames: headerStyles.headerEntityLogoDesktopClassNames,
      headerEntityLogoMobileClassNames: headerStyles.headerEntityLogoMobileClassNames,
      headerPointsContainerClassNames: headerStyles.headerPointsContainerClassNames,
      headerPointsValueClassNames: headerStyles.headerPointsValueClassNames,
      headerPointsLabelClassNames: headerStyles.headerPointsLabelClassNames,
      headerRefreshPointsButtonClassNames: headerStyles.headerRefreshPointsButtonClassNames,
      headerSpanPointsClassNames: headerStyles.headerSpanPointsClassNames,
      headerPointsIconClassNames: headerStyles.headerPointsIconClassNames,
      headerProfilePictureClassNames: headerStyles.headerProfilePictureClassNames,
      headerProfilePictureLetterClassNames: headerStyles.headerProfilePictureLetterClassNames,
      headerProfileNameClassNames: headerStyles.headerProfileNameClassNames,
      headerProfileIconClassNames: headerStyles.headerProfileIconClassNames,
      headerSeparatorClassNames: headerStyles.headerSeparatorClassNames,
      headerLoginButtonClassNames: headerStyles.headerLoginButtonClassNames,
      headerLogoutButtonClassNames: headerStyles.headerLogoutButtonClassNames,
      headerLogoutIconButtonClassNames: headerStyles.headerLogoutIconButtonClassNames,
      headerDivisionClassNames: headerStyles.headerDivisionClassNames,
      headerLanguageConfigButtonClassNames: headerStyles.headerLanguageConfigButtonClassNames,
      headerCurrencyConfigButtonClassNames: headerStyles.headerCurrencyConfigButtonClassNames,
      headerDropdownNameClassNames: headerStyles.headerDropdownNameClassNames,
      headerDropdownEmailClassNames: headerStyles.headerDropdownEmailClassNames,
      headerDropdownPointsClassNames: headerStyles.headerDropdownPointsClassNames,
      headerDropdownItemClassNames: headerStyles.headerDropdownItemClassNames,
      headerDropdownItemIconClassNames: headerStyles.headerDropdownItemIconClassNames
    },
    reservations: {
      cars: {
        carBookingCard: {
          statusTitle: carBookingCardStyles.statusTitle,
          cardContainer: carBookingCardStyles.cardContainer,
          carRentalInfoContainer: carBookingCardStyles.carRentalInfoContainer,
          carRentalImagesContainer: carBookingCardStyles.carRentalImagesContainer,
          carModelContainer: carBookingCardStyles.carModelContainer,
          carModelContainerMobile: carBookingCardStyles.carModelContainerMobile,
          carModel: carBookingCardStyles.carModel,
          carModelSpan: carBookingCardStyles.carModelSpan,
          carCompanyImage: carBookingCardStyles.carCompanyImage,
          carInformationContainer: carBookingCardStyles.carInformationContainer,
          carCharacteristicsContainer: carBookingCardStyles.carCharacteristicsContainer,
          carCharacteristicsIcon: carBookingCardStyles.carCharacteristicsIcon,
          divider: carBookingCardStyles.divider,
          priceContainer: carBookingCardStyles.priceContainer,
          priceButton: carBookingCardStyles.priceButton,
          priceCardPointsClass: carBookingCardStyles.priceCardPointsClass,
          priceCardCashClass: carBookingCardStyles.priceCardCashClass,
          priceTitle: carBookingCardStyles.priceTitle,
          priceFeeDisclaimer: carBookingCardStyles.priceFeeDisclaimer
        },
        carBookingPage: {
          carBookingDetails: {
            container: carBookingPageStyles.carBookingDetailsContainer
          },
          carBookingDetailsCarInfo: {
            CarInfoContainer: carBookingPageStyles.CarInfoContainer,
            carInfoInnerContainer: carBookingPageStyles.carInfoInnerContainer,
            CarInfoImage: carBookingPageStyles.CarInfoImage,
            carModelContainer: carBookingPageStyles.carModelContainer,
            carModel: carBookingPageStyles.carModel,
            carModelSpan: carBookingPageStyles.carModelSpan,
            carCompanyImage: carBookingPageStyles.carCompanyImage,
            carCharacteristicsContainer: carBookingPageStyles.carCharacteristicsContainer,
            carCharacteristicsItem: carBookingPageStyles.carCharacteristicsItem
          },
          carBookingDetailsPickupDropoff: {
            carPickupDropoffContainer: carBookingPageStyles.carPickupDropoffContainer,
            carPickupDropoffHeader: carBookingPageStyles.carPickupDropoffHeader,
            carPickupDropoffInfoRow: carBookingPageStyles.carPickupDropoffInfoRow,
            carPickupDropoffIconColor: carBookingPageStyles.carPickupDropoffIconColor,
            carPickupDropoffIconSize: carBookingPageStyles.carPickupDropoffIconSize
          },
          carBookingDetailsRate: {
            carRateContainer: carBookingPageStyles.carRateContainer,
            carRateDetailsTitle: carBookingPageStyles.carRateDetailsTitle,
            carRateDetailsList: carBookingPageStyles.carRateDetailsList,
            carRateInclusionTitle: carBookingPageStyles.carRateInclusionTitle,
            carRateInclusionList: carBookingPageStyles.carRateInclusionList,
            carRateToPayContainer: carBookingPageStyles.carRateToPayContainer,
            carRateToPayTitle: carBookingPageStyles.carRateToPayTitle,
            carRateToPayPoints: carBookingPageStyles.carRateToPayPoints,
            carRateToPaySeparator: carBookingPageStyles.carRateToPaySeparator,
            carRateToPayCash: carBookingPageStyles.carRateToPayCash
          },
          carBookingDetailsPricing: {
            carBookingDetailsPricingContainer: carBookingPageStyles.carBookingDetailsPricingContainer,
            carBookingDetailsPricingButton: carBookingPageStyles.carBookingDetailsPricingButton,
            carBookingDetailsPricingFooterContainer: carBookingPageStyles.carBookingDetailsPricingFooterContainer,
            carBookingDetailsPricingFooterButton: carBookingPageStyles.carBookingDetailsPricingFooterButton
          },
          driverInformation: {
            detailTitleClass: carBookingPageStyles.detailTitleClass,
            importantTextClass: carBookingPageStyles.importantTextClass,
            importantTextValueClass: carBookingPageStyles.importantTextValueClass
          },
          divider: carBookingPageStyles.divider,
          price: {
            priceTitleClass: carBookingPageStyles.priceTitleClass,
            pricePointsClass: carBookingPageStyles.pricePointsClass,
            priceCashClass: carBookingPageStyles.priceCashClass,
            taxesMessageClass: carBookingPageStyles.taxesMessageClass,
            taxesValueClass: carBookingPageStyles.taxesValueClass
          }
        }
      },
      hotels: {
        hotelBookingCard: {
          statusTitle: hotelBookingCardStyles.statusTitle,
          cardContainer: hotelBookingCardStyles.cardContainer,
          imageGalleryContainer: hotelBookingCardStyles.imageGalleryContainer,
          hotelInfoContainer: hotelBookingCardStyles.hotelInfoContainer,
          hotelName: hotelBookingCardStyles.hotelName,
          hotelLocation: hotelBookingCardStyles.hotelLocation,
          hotelTypeAndRatingContainer: hotelBookingCardStyles.hotelTypeAndRatingContainer,
          hotelTypeAndRatingChipType: hotelBookingCardStyles.hotelTypeAndRatingChipType,
          hotelAmenitiesChip: hotelBookingCardStyles.hotelAmenitiesChip,
          hotelAmenitiesText: hotelBookingCardStyles.hotelAmenitiesText,
          hotelAmenitiesIcon: hotelBookingCardStyles.hotelAmenitiesIcon,
          priceContainer: hotelBookingCardStyles.priceContainer,
          priceTitle: hotelBookingCardStyles.priceTitle,
          pricePointsText: hotelBookingCardStyles.pricePointsText,
          priceCashText: hotelBookingCardStyles.priceCashText,
          priceBelowText: hotelBookingCardStyles.priceBelowText,
          hotelBookingDetailsButton: hotelBookingCardStyles.hotelBookingDetailsButton
        },
        hotelBookingDetails: {
          statusTitle: hotelBookingDetailsStyles.statusTitle,
          imageContainer: hotelBookingDetailsStyles.imageContainer,
          hotelInfoContainer: hotelBookingDetailsStyles.hotelInfoContainer,
          hotelName: hotelBookingDetailsStyles.hotelName,
          hotelLocation: hotelBookingDetailsStyles.hotelLocation,
          hotelTypeAndRatingContainer: hotelBookingDetailsStyles.hotelTypeAndRatingContainer,
          hotelAmenitiesContainer: hotelBookingDetailsStyles.hotelAmenitiesContainer,
          hotelAmenitiesChip: hotelBookingDetailsStyles.hotelAmenitiesChip,
          hotelAmenitiesChipIcon: hotelBookingDetailsStyles.hotelAmenitiesChipIcon,
          hotelRetirementContainer: hotelBookingDetailsStyles.hotelRetirementContainer,
          hotelInfoTitles: hotelBookingDetailsStyles.hotelInfoTitles,
          hotelRetirementIcon: hotelBookingDetailsStyles.hotelRetirementIcon,
          hotelRetirementText: hotelBookingDetailsStyles.hotelRetirementText,
          hotelGuestsInfoIcon: hotelBookingDetailsStyles.hotelGuestsInfoIcon,
          hotelGuestsInfoText: hotelBookingDetailsStyles.hotelGuestsInfoText,
          hotelAmenitiesChecksText: hotelBookingDetailsStyles.hotelAmenitiesChecksText,
          hotelAmenitiesChecksIcon: hotelBookingDetailsStyles.hotelAmenitiesChecksIcon,
          hotelAmenitiesChecksSeeMore: hotelBookingDetailsStyles.hotelAmenitiesChecksSeeMore,
          hotelAmenitiesChecksSeeMoreIcon: hotelBookingDetailsStyles.hotelAmenitiesChecksSeeMoreIcon,
          hotelImportantDisclaimerText: hotelBookingDetailsStyles.hotelImportantDisclaimerText,
          hotelImportantDisclaimerIcon: hotelBookingDetailsStyles.hotelImportantDisclaimerIcon,
          hotelImportantInfo: hotelBookingDetailsStyles.hotelImportantInfo,
          hotelImportantInfoValue: hotelBookingDetailsStyles.hotelImportantInfoValue,
          hotelImportantInfoSeeMore: hotelBookingDetailsStyles.hotelImportantInfoSeeMore,
          priceContainer: hotelBookingDetailsStyles.priceContainer,
          priceTitle: hotelBookingDetailsStyles.priceTitle,
          priceCash: hotelBookingDetailsStyles.priceCash,
          pricePoints: hotelBookingDetailsStyles.pricePoints,
          priceBelowText: hotelBookingDetailsStyles.priceBelowText,
          priceBelowTextValue: hotelBookingDetailsStyles.priceBelowTextValue,
          dividerContainer: hotelBookingDetailsStyles.dividerContainer,
          dividerConfig: hotelBookingDetailsStyles.dividerConfig
        }
      },
      flights: {
        flightBookingCard: {
          mainContainer: flightBookingCardStyles.mainContainer,
          iataClassNames: flightBookingCardStyles.iataClassNames,
          flightTypeArrowClassNames: flightBookingCardStyles.flightTypeArrowClassNames,
          classClassNames: flightBookingCardStyles.classClassNames,
          flightTypeTitleClassNames: flightBookingCardStyles.flightTypeTitleClassNames,
          flightTypeIconsClassNames: flightBookingCardStyles.flightTypeIconsClassNames,
          flightTypeLabelsClassNames: flightBookingCardStyles.flightTypeLabelsClassNames,
          airplaneIcon: flightBookingCardStyles.airplaneIcon,
          priceContainer: flightBookingCardStyles.priceContainer,
          priceTitle: flightBookingCardStyles.priceTitle,
          pricePointsText: flightBookingCardStyles.pricePointsText,
          priceCashText: flightBookingCardStyles.priceCashText,
          priceBelowIcon: flightBookingCardStyles.priceBelowIcon,
          priceBelowText: flightBookingCardStyles.priceBelowText,
          buttonsContainer: flightBookingCardStyles.buttonsContainer,
          buttonSeeDetails: flightBookingCardStyles.buttonSeeDetails,
          buttonAddBaggageIcon: flightBookingCardStyles.buttonAddBaggageIcon,
          buttonAddBaggage: flightBookingCardStyles.buttonAddBaggage
        },
        flightsBookingDetails: {
          titleClassNames: flightBookingDetailsStyles.titleClassNames,
          timeLabelClassNames: flightBookingDetailsStyles.timeLabelClassNames,
          flightTitleClassNames: flightBookingDetailsStyles.flightTitleClassNames,
          flightNumberClassNames: flightBookingDetailsStyles.flightNumberClassNames,
          flightNumberOperatorClassNames: flightBookingDetailsStyles.flightNumberOperatorClassNames,
          flightInfoDateClassNames: flightBookingDetailsStyles.flightInfoDateClassNames,
          flightInfoLocationClassNames: flightBookingDetailsStyles.flightInfoLocationClassNames,
          flightInfoTimeClassNames: flightBookingDetailsStyles.flightInfoTimeClassNames,
          flightInfoTimeIndicatorClassNames: flightBookingDetailsStyles.flightInfoTimeIndicatorClassNames,
          flightInfoScaleChipClassNames: flightBookingDetailsStyles.flightInfoScaleChipClassNames,
          flightInfoScaleDurationClassNames: flightBookingDetailsStyles.flightInfoScaleDurationClassNames,
          flightInfoClassClassNames: flightBookingDetailsStyles.flightInfoClassClassNames,
          flightInfoSeeDetailsClassNames: flightBookingDetailsStyles.flightInfoSeeDetailsClassNames,
          flightInfoSeeDetailsIconClassNames: flightBookingDetailsStyles.flightInfoSeeDetailsIconClassNames,
          passengerInfoClassNames: flightBookingDetailsStyles.passengerInfoClassNames,
          baggageTabClassNames: flightBookingDetailsStyles.baggageTabClassNames,
          baggageTabActiveClassNames: flightBookingDetailsStyles.baggageTabActiveClassNames,
          baggageTitleClassNames: flightBookingDetailsStyles.baggageTitleClassNames,
          baggageInfoClassNames: flightBookingDetailsStyles.baggageInfoClassNames,
          baggagePriceIconClassNames: flightBookingDetailsStyles.baggagePriceIconClassNames,
          baggageCheckIconClassNames: flightBookingDetailsStyles.baggageCheckIconClassNames,
          baggageXIconClassNames: flightBookingDetailsStyles.baggageXIconClassNames,
          baggageAddClassNames: flightBookingDetailsStyles.baggageAddClassNames,
          baggageAddIconClassNames: flightBookingDetailsStyles.baggageAddIconClassNames,
          dividerClassNames: flightBookingDetailsStyles.dividerClassNames,
          baggageNotSupportedClassNames: flightBookingDetailsStyles.baggageNotSupportedClassNames,
          importantTitleClassNames: flightBookingDetailsStyles.importantTitleClassNames,
          importantValueClassNames: flightBookingDetailsStyles.importantValueClassNames,
          priceTitleClassNames: flightBookingDetailsStyles.priceTitleClassNames,
          pricePointsClassNames: flightBookingDetailsStyles.pricePointsClassNames,
          priceCashClassNames: flightBookingDetailsStyles.priceCashClassNames,
          priceTaxesClassNames: flightBookingDetailsStyles.priceTaxesClassNames,
          cancelationsClassNames: flightBookingDetailsStyles.cancelationsClassNames,
          scaleIconClassNames: flightBookingDetailsStyles.scaleIconClassNames,
          scaleDurationClassNames: flightBookingDetailsStyles.scaleDurationClassNames
        },
        flightsBaggage: {
          titleClassNames: flightBaggageStyles.titleClassNames,
          subtitleClassNames: flightBaggageStyles.subtitleClassNames,
          baggageFlightTabContainerClassNames: flightBaggageStyles.baggageFlightTabContainerClassNames,
          baggageFlightTabContainerActiveClassNames: flightBaggageStyles.baggageFlightTabContainerActiveClassNames,
          baggageFlightTabTitleClassNames: flightBaggageStyles.baggageFlightTabTitleClassNames,
          baggageFlightTabTitleActiveClassNames: flightBaggageStyles.baggageFlightTabTitleActiveClassNames,
          baggageIncludedContainerClassNames: flightBaggageStyles.baggageIncludedContainerClassNames,
          baggageIncludedTitleClassNames: flightBaggageStyles.baggageIncludedTitleClassNames,
          baggageIncludedInfoClassNames: flightBaggageStyles.baggageIncludedInfoClassNames,
          baggageIncludedIconClassNames: flightBaggageStyles.baggageIncludedIconClassNames,
          baggageContainerClassNames: flightBaggageStyles.baggageContainerClassNames,
          baggageSelectPassengerClassNames: flightBaggageStyles.baggageSelectPassengerClassNames,
          baggageSelectPassengerArrowsClassNames: flightBaggageStyles.baggageSelectPassengerArrowsClassNames,
          baggageCheckClassNames: flightBaggageStyles.baggageCheckClassNames,
          baggageCheckTitleClassNames: flightBaggageStyles.baggageCheckTitleClassNames,
          baggageCheckInfoNames: flightBaggageStyles.baggageCheckInfoNames,
          baggageCheckInfoDisabledClassNames: flightBaggageStyles.baggageCheckInfoDisabledClassNames,
          baggageCheckPointsClassNames: flightBaggageStyles.baggageCheckPointsClassNames,
          baggageCheckCashClassNames: flightBaggageStyles.baggageCheckCashClassNames,
          priceTitleClassNames: flightBaggageStyles.priceTitleClassNames,
          pricePointsClassNames: flightBaggageStyles.pricePointsClassNames,
          priceCashClassNames: flightBaggageStyles.priceCashClassNames,
          priceTaxesClassNames: flightBaggageStyles.priceTaxesClassNames,
          resumeContainerClassNames: flightBaggageStyles.resumeContainerClassNames,
          resumeTitleClassNames: flightBaggageStyles.resumeTitleClassNames,
          resumeSubtitleClassNames: flightBaggageStyles.resumeSubtitleClassNames,
          resumeInfoClassNames: flightBaggageStyles.resumeInfoClassNames,
          resumeIconClassNames: flightBaggageStyles.resumeIconClassNames
        }
      }
    },
    profile: {
      profileHeader: {
        container: profileHeaderStyles.container,
        circleContainer: profileHeaderStyles.circleContainer,
        circleLetter: profileHeaderStyles.circleLetter,
        salutation: profileHeaderStyles.salutation,
        pointsValue: profileHeaderStyles.pointsValue,
        pointsLabel: profileHeaderStyles.pointsLabel,
        circleEditIconContainer: profileHeaderStyles.circleEditIconContainer,
        circleEditIcon: profileHeaderStyles.circleEditIcon
      },
      profileMenu: {
        icon: profileMenuStyles.icon,
        text: profileMenuStyles.text,
        activeText: profileMenuStyles.activeText,
        arrow: profileMenuStyles.arrow
      },
      profileLogout: {
        button: profileLogoutStyles.button,
        buttonText: profileLogoutStyles.buttonText,
        buttonIcon: profileLogoutStyles.buttonIcon
      },
      profileTabs: {
        activeTabBorderClassname: profileTabsStyles.activeTabBorderClassname,
        activeIconColor: profileTabsStyles.activeIconColor,
        activeText: profileTabsStyles.activeText,
        baseText: profileTabsStyles.baseText
      }
    },
    favorites: {
      container: {
        mainContainer: favoritesContainerStyles.mainContainer,
        listContainer: favoritesContainerStyles.listContainer,
        cardContainer: favoritesContainerStyles.cardContainer,
        addButton: favoritesContainerStyles.addButton,
        addButtonIcon: favoritesContainerStyles.addButtonIcon,
        addButtonContainer: favoritesContainerStyles.addButtonContainer
      },
      newFavoritePassenger: {
        container: newFavoritePassengerStyles.container,
        formContainer: newFavoritePassengerStyles.formContainer,
        button: newFavoritePassengerStyles.button,
        buttonsContainer: newFavoritePassengerStyles.buttonsContainer
      },
      newTravelerDocument: {
        container: newTravelerDocumentStyles.container,
        mobileContainer: newTravelerDocumentStyles.mobileContainer,
        formContainer: newTravelerDocumentStyles.formContainer,
        button: newTravelerDocumentStyles.button,
        buttonsContainer: newTravelerDocumentStyles.buttonsContainer
      },
      newFrequentFlyer: {
        container: newFrequentFlyerStyles.container,
        formContainer: newFrequentFlyerStyles.formContainer,
        button: newFrequentFlyerStyles.button,
        buttonsContainer: newFrequentFlyerStyles.buttonsContainer
      },
      flyerProfile: {
        container: flyerProfileStyles.container,
        passengerNameContainer: flyerProfileStyles.passengerNameContainer,
        passengerName: flyerProfileStyles.passengerName,
        favoriteIcon: flyerProfileStyles.favoriteIcon,
        actionsContainer: flyerProfileStyles.actionsContainer,
        editIcon: flyerProfileStyles.editIcon,
        deleteIcon: flyerProfileStyles.deleteIcon
      },
      frequentFlyerInfo: {
        headerContainer: frequentFlyerInfoStyles.headerContainer,
        divider: frequentFlyerInfoStyles.divider,
        titleContainer: frequentFlyerInfoStyles.titleContainer,
        title: frequentFlyerInfoStyles.title,
        expandIcon: frequentFlyerInfoStyles.expandIcon,
        documentSectionContainer: frequentFlyerInfoStyles.documentSectionContainer,
        documentTypeContainer: frequentFlyerInfoStyles.documentTypeContainer,
        documentTypeValue: frequentFlyerInfoStyles.documentTypeValue,
        documentContainer: frequentFlyerInfoStyles.documentContainer,
        documentActions: frequentFlyerInfoStyles.documentActions,
        documentEditIcon: frequentFlyerInfoStyles.documentEditIcon,
        documentDeleteIcon: frequentFlyerInfoStyles.documentDeleteIcon,
        addButton: frequentFlyerInfoStyles.addButton,
        addButtonText: frequentFlyerInfoStyles.addButtonText,
        editButton: frequentFlyerInfoStyles.editButton
      },
      travelDocuments: {
        headerContainer: travelDocumentsStyles.headerContainer,
        divider: travelDocumentsStyles.divider,
        titleContainer: travelDocumentsStyles.titleContainer,
        title: travelDocumentsStyles.title,
        expandIcon: travelDocumentsStyles.expandIcon,
        documentSectionContainer: travelDocumentsStyles.documentSectionContainer,
        documentContainer: travelDocumentsStyles.documentContainer,
        documentTypeContainer: travelDocumentsStyles.documentTypeContainer,
        documentTypeValue: travelDocumentsStyles.documentTypeValue,
        documentActions: travelDocumentsStyles.documentActions,
        documentEditIcon: travelDocumentsStyles.documentEditIcon,
        documentDeleteIcon: travelDocumentsStyles.documentDeleteIcon,
        addButton: travelDocumentsStyles.addButton,
        addButtonText: travelDocumentsStyles.addButtonText,
        editButton: travelDocumentsStyles.editButton
      }
    },
    creditCards: {
      creditCardsTableA: {
        listTitle: creditCardsTableAStyles.listTitle,
        cardContainer: creditCardsTableAStyles.cardContainer,
        deleteIcon: creditCardsTableAStyles.deleteIcon,
        cardCompanyLogo: creditCardsTableAStyles.cardCompanyLogo,
        cardNumber: creditCardsTableAStyles.cardNumber,
        radioContainer: creditCardsTableAStyles.radioContainer,
        radioButtonActive: creditCardsTableAStyles.radioButtonActive,
        radioButtonInactive: creditCardsTableAStyles.radioButtonInactive,
        principalBadge: creditCardsTableAStyles.principalBadge,
        addCardButton: creditCardsTableAStyles.addCardButton,
        addCardButtonIcon: creditCardsTableAStyles.addCardButtonIcon
      },
      modalCreditCards: {
        modalTitle: modalCreditCardsStyles.modalTitle,
        titles: modalCreditCardsStyles.titles,
        checkBoxActive: modalCreditCardsStyles.checkBoxActive,
        checkBoxInactive: modalCreditCardsStyles.checkBoxInactive,
        checkBoxLabel: modalCreditCardsStyles.checkBoxLabel,
        buttonsContainer: modalCreditCardsStyles.buttonsContainer,
        saveButton: modalCreditCardsStyles.saveButton,
        cancelButton: modalCreditCardsStyles.cancelButton
      }
    }
  },
  flights: {
    flightSearchHeaderSummary: {
      infoMainTextClassName: flightSearchHeaderSummaryStyles.infoMainTextClassName,
      infoTextClassName: flightSearchHeaderSummaryStyles.infoTextClassName,
      infoIconClassName: flightSearchHeaderSummaryStyles.infoIconClassName,
      actionsIconClassName: flightSearchHeaderSummaryStyles.actionsIconClassName,
      yDivisionLineClassName: flightSearchHeaderSummaryStyles.yDivisionLineClassName,
      dotSearchHeaderClassName: flightSearchHeaderSummaryStyles.dotSearchHeaderClassName,
      searchDataSummaryTitleClassName: flightSearchHeaderSummaryStyles.searchDataSummaryTitleClassName,
      searchDataSummaryTextClassName: flightSearchHeaderSummaryStyles.searchDataSummaryTextClassName,
      dotDataSummaryClassName: flightSearchHeaderSummaryStyles.dotDataSummaryClassName,
      containerClassName: flightSearchHeaderSummaryStyles.containerClassName,
      searchDataSummaryIcon: flightSearchHeaderSummaryStyles.searchDataSummaryIcon
    },
    flightSearchFareDetails: {
      fareDetailsTitleClassNames: flightSearchFareDetailsStyles.fareDetailsTitleClassNames,
      fareDetailsTitleActiveClassNames: flightSearchFareDetailsStyles.fareDetailsTitleActiveClassNames,
      fareDetailsTypeBaseClassNames: flightSearchFareDetailsStyles.fareDetailsTypeBaseClassNames,
      fareDetailsTypeRecommendedClassNames: flightSearchFareDetailsStyles.fareDetailsTypeRecommendedClassNames,
      fareDetailsTypeUpClassNames: flightSearchFareDetailsStyles.fareDetailsTypeUpClassNames,
      fareDetailsTypeDownClassNames: flightSearchFareDetailsStyles.fareDetailsTypeDownClassNames,
      fareDetailsTypeIconsClassNames: flightSearchFareDetailsStyles.fareDetailsTypeIconsClassNames,
      fareDetailsSubTitleClassNames: flightSearchFareDetailsStyles.fareDetailsSubTitleClassNames,
      fareDetailsInfoClassNames: flightSearchFareDetailsStyles.fareDetailsInfoClassNames,
      fareDetailsPriceIconClassNames: flightSearchFareDetailsStyles.fareDetailsPriceIconClassNames,
      fareDetailsCheckIconClassNames: flightSearchFareDetailsStyles.fareDetailsCheckIconClassNames,
      fareDetailsXIconClassNames: flightSearchFareDetailsStyles.fareDetailsXIconClassNames,
      fareDividerClassNames: flightSearchFareDetailsStyles.fareDividerClassNames,
      farePriceTitleClassNames: flightSearchFareDetailsStyles.farePriceTitleClassNames,
      farePriceCashClassNames: flightSearchFareDetailsStyles.farePriceCashClassNames,
      farePricePointsClassNames: flightSearchFareDetailsStyles.farePricePointsClassNames,
      farePerPersonIconClassNames: flightSearchFareDetailsStyles.farePerPersonIconClassNames,
      farePerPersonLabelClassNames: flightSearchFareDetailsStyles.farePerPersonLabelClassNames,
      fareSelectButtonClassNames: flightSearchFareDetailsStyles.fareSelectButtonClassNames,
      fareSelectButtonActiveClassNames: flightSearchFareDetailsStyles.fareSelectButtonActiveClassNames
    },
    flightItinerary: {
      iteneraryFlightInfoClassNames: {
        iteneraryTitleClassNames: itineraryFlightInfoStyles.iteneraryTitleClassNames,
        itenerarySubtitleClassNames: itineraryFlightInfoStyles.itenerarySubtitleClassNames,
        itenerarySubtitleDisclaimerClassNames: itineraryFlightInfoStyles.itenerarySubtitleDisclaimerClassNames,
        itineraryFlightInfoContainerClassNames: itineraryFlightInfoStyles.itineraryFlightInfoContainerClassNames,
        itineraryFlightInfoTitlesClassNames: itineraryFlightInfoStyles.itineraryFlightInfoTitlesClassNames,
        itineraryFlightInfoBaggageIconClassNames: itineraryFlightInfoStyles.itineraryFlightInfoBaggageIconClassNames,
        itineraryFlightInfoImageClassNames: itineraryFlightInfoStyles.itineraryFlightInfoImageClassNames,
        itineraryFlightInfoNumberClassNames: itineraryFlightInfoStyles.itineraryFlightInfoNumberClassNames,
        itineraryFlightInfoDateClassNames: itineraryFlightInfoStyles.itineraryFlightInfoDateClassNames,
        itineraryFlightInfoLocationClassNames: itineraryFlightInfoStyles.itineraryFlightInfoLocationClassNames,
        itineraryFlightInfoLocationIataClassNames: itineraryFlightInfoStyles.itineraryFlightInfoLocationIataClassNames,
        itineraryFlightInfoTimeClassNames: itineraryFlightInfoStyles.itineraryFlightInfoTimeClassNames,
        itineraryFlightInfoTimeIndicatorClassNames: itineraryFlightInfoStyles.itineraryFlightInfoTimeIndicatorClassNames,
        itineraryFlightInfoAirplaneIconClassNames: itineraryFlightInfoStyles.itineraryFlightInfoAirplaneIconClassNames,
        itineraryFlightInfoAirplaneDottedLineExtremesClassNames: itineraryFlightInfoStyles.itineraryFlightInfoAirplaneDottedLineExtremesClassNames,
        itineraryFlightInfoAirplaneDottedLineMiddleClassNames: itineraryFlightInfoStyles.itineraryFlightInfoAirplaneDottedLineMiddleClassNames,
        itineraryFlightInfoScaleClassNames: itineraryFlightInfoStyles.itineraryFlightInfoScaleClassNames,
        itineraryFlightInfoScaleTimeClassNames: itineraryFlightInfoStyles.itineraryFlightInfoScaleTimeClassNames,
        itineraryFlightChangeButtonClassNames: itineraryFlightInfoStyles.itineraryFlightChangeButtonClassNames,
        itineraryFlightClassClassNames: itineraryFlightInfoStyles.itineraryFlightClassClassNames,
        itineraryFlightSeeDetailsIconClassNames: itineraryFlightInfoStyles.itineraryFlightSeeDetailsIconClassNames,
        itineraryFlightSeeDetailsTextClassNames: itineraryFlightInfoStyles.itineraryFlightSeeDetailsTextClassNames,
        itineraryFlightBaggageSubtitleClassNames: itineraryFlightInfoStyles.itineraryFlightBaggageSubtitleClassNames,
        itineraryFlightBaggageInfoClassNames: itineraryFlightInfoStyles.itineraryFlightBaggageInfoClassNames,
        itineraryFlightBaggagePriceIconClassNames: itineraryFlightInfoStyles.itineraryFlightBaggagePriceIconClassNames,
        itineraryFlightBaggageCheckIconClassNames: itineraryFlightInfoStyles.itineraryFlightBaggageCheckIconClassNames,
        itineraryFlightBaggageXIconClassNames: itineraryFlightInfoStyles.itineraryFlightBaggageXIconClassNames
      },
      iteneraryResumeClassNames: {
        itineraryResumeTitleClassNames: itineraryResumeStyles.itineraryResumeTitleClassNames,
        itineraryResumeTitlesClassNames: itineraryResumeStyles.itineraryResumeTitlesClassNames,
        itineraryResumeTitlesIconClassNames: itineraryResumeStyles.itineraryResumeTitlesIconClassNames,
        itineraryResumeSubTitleClassNames: itineraryResumeStyles.itineraryResumeSubTitleClassNames,
        itineraryResumeSubTitleIconClassNames: itineraryResumeStyles.itineraryResumeSubTitleIconClassNames,
        itineraryResumeAirportInfoClassNames: itineraryResumeStyles.itineraryResumeAirportInfoClassNames,
        itineraryResumenPassegerInfoClassNames: itineraryResumeStyles.itineraryResumenPassegerInfoClassNames,
        itineraryResumeBaggageInfoTitleClassNames: itineraryResumeStyles.itineraryResumeBaggageInfoTitleClassNames,
        itineraryResumeBaggageInfoValueClassNames: itineraryResumeStyles.itineraryResumeBaggageInfoValueClassNames,
        itineraryResumeBaggagePriceIconClassNames: itineraryResumeStyles.itineraryResumeBaggagePriceIconClassNames,
        itineraryResumeBaggageCheckIconClassNames: itineraryResumeStyles.itineraryResumeBaggageCheckIconClassNames,
        itineraryResumeBaggageXIconClassNames: itineraryResumeStyles.itineraryResumeBaggageXIconClassNames,
        itineraryResumeBaggageTabBaseClassNames: itineraryResumeStyles.itineraryResumeBaggageTabBaseClassNames,
        itineraryResumeBaggageTabSelectedClassNames: itineraryResumeStyles.itineraryResumeBaggageTabSelectedClassNames,
        iteneraryResumeClassClassNames: itineraryResumeStyles.iteneraryResumeClassClassNames,
        itineraryResumeSeeDetailsButtonClassNames: itineraryResumeStyles.itineraryResumeSeeDetailsButtonClassNames,
        itineraryResumeSeeDetailsButtonIconClassNames: itineraryResumeStyles.itineraryResumeSeeDetailsButtonIconClassNames,
        iteneraryResumeBaggageInfoTitleClassNames: itineraryResumeStyles.iteneraryResumeBaggageInfoTitleClassNames,
        iteneraryResumeBaggageInfoTitleIconClassNames: itineraryResumeStyles.itineraryResumeBaggageInfoTitleIconClassNames,
        iteneraryResumeBaggageInfoItemsTitleClassNames: itineraryResumeStyles.iteneraryResumeBaggageInfoItemsTitleClassNames,
        iteneraryResumeBaggageInfoItemsTextClassNames: itineraryResumeStyles.iteneraryResumeBaggageInfoItemsTextClassNames
      },
      iteneraryPriceClassNames: {
        itineraryPriceBreakDownTypeClassNames: itineraryPriceStyles.itineraryPriceBreakDownTypeClassNames,
        itineraryPriceBreakDownValueClassNames: itineraryPriceStyles.itineraryPriceBreakDownValueClassNames,
        itenerarySeeResumeButtonClassNames: itineraryPriceStyles.itenerarySeeResumeButtonClassNames
      }
    },
    flightModals: {
      flightDetailsModal: {
        title: flightDetailsModalStyles.title,
        flightTitleClassNames: flightDetailsModalStyles.flightTitleClassNames,
        flightTitleIconClassNames: flightDetailsModalStyles.flightTitleIconClassNames,
        scaleIconClassNames: flightDetailsModalStyles.scaleIconClassNames,
        dateClassNames: flightDetailsModalStyles.dateClassNames,
        airportClassNames: flightDetailsModalStyles.airportClassNames,
        flightDetailsTitleClassNames: flightDetailsModalStyles.flightDetailsTitleClassNames,
        flightDetailsValueClassNames: flightDetailsModalStyles.flightDetailsValueClassNames,
        airplaneDisclaimerClassNames: flightDetailsModalStyles.airplaneDisclaimerClassNames
      }
    },
    flightCard: {
      airlineLogoClassName: flightCardStyles.airlineLogoClassName,
      airlineNameClassName: flightCardStyles.airlineNameClassName,
      operatorNameClassName: flightCardStyles.operatorNameClassName,
      iataClassName: flightCardStyles.iataClassName,
      iconClassName: flightCardStyles.iconClassName,
      timeClassName: flightCardStyles.timeClassName,
      scaleClassName: flightCardStyles.scaleClassName,
      titleClassName: flightCardStyles.titleClassName,
      priceCashClassName: flightCardStyles.priceCashClassName,
      pricePointsClassName: flightCardStyles.pricePointsClassName,
      perPersonIconClassName: flightCardStyles.perPersonIconClassName,
      perPersonTextClassName: flightCardStyles.perPersonTextClassName,
      taxClassName: flightCardStyles.taxClassName,
      spinnerClassName: flightCardStyles.spinnerClassName
    },
    flightCalendarCard: {
      container: flightCalendarCardStyles.container,
      cardSelected: flightCalendarCardStyles.cardSelected,
      cardUnselected: flightCalendarCardStyles.cardUnselected,
      priceContainer: flightCalendarCardStyles.priceContainer,
      dateTextSelected: flightCalendarCardStyles.dateTextSelected,
      dateTextUnselected: flightCalendarCardStyles.dateTextUnselected,
      pointsTextSelected: flightCalendarCardStyles.pointsTextSelected,
      pointsTextUnselected: flightCalendarCardStyles.pointsTextUnselected,
      cashTextSelected: flightCalendarCardStyles.cashTextSelected,
      cashTextUnselected: flightCalendarCardStyles.cashTextUnselected,
      priceIconSelected: flightCalendarCardStyles.priceIconSelected,
      priceIconUnselected: flightCalendarCardStyles.priceIconUnselected
    },
    flightSelectedFlightsHeader: {
      flightChipContainerClassName: flightSelectedFlightsHeaderStyles.flightChipContainerClassName,
      flightChipIconClassName: flightSelectedFlightsHeaderStyles.flightChipIconClassName,
      checkIconClassName: flightSelectedFlightsHeaderStyles.checkIconClassName,
      dateClassName: flightSelectedFlightsHeaderStyles.dateClassName,
      infoDateClassName: flightSelectedFlightsHeaderStyles.infoDateClassName,
      planeTakeClassName: flightSelectedFlightsHeaderStyles.planeTakeClassName
    },
    flightPurchase: {
      flightPurchaseDetails: {
        container: flightPurchaseDetailsStyles.container,
        resumeTitleClassNames: flightPurchaseDetailsStyles.resumeTitleClassNames,
        resumeBaggageTabBaseClassNames: flightPurchaseDetailsStyles.resumeBaggageTabBaseClassNames,
        resumeBaggageTabSelectedClassNames: flightPurchaseDetailsStyles.resumeBaggageTabSelectedClassNames
      }
    },
    passengerForm: {
      expandableIcon: passengerFormStyles.expandableIcon,
      passengerFormTitle: passengerFormStyles.passengerFormTitle,
      errorIcon: passengerFormStyles.errorIcon,
      checkIcon: passengerFormStyles.checkIcon,
      iconsContainer: passengerFormStyles.iconsContainer,
      passengerFormCardTitle: passengerFormStyles.passengerFormCardTitle,
      passengerFormCardContainer: passengerFormStyles.passengerFormCardContainer
    }
  },
  views: {
    desktop: {
      PassengerSelection: {
        passengerSelectionTitle: passengerSelectionDesktopStyles.passengerSelectionTitle,
        passengersQuantitySelectorContainer: passengerSelectionDesktopStyles.passengersQuantitySelectorContainer,
        passengersQuantitySelectorButton: passengerSelectionDesktopStyles.passengersQuantitySelectorButton,
        passengersQuantitySelectorButtonIcon: passengerSelectionDesktopStyles.passengersQuantitySelectorButtonIcon,
        passengersApplyButtonContainer: passengerSelectionDesktopStyles.passengersApplyButtonContainer
      }
    },
    mobile: {
      PassengerSelection: {
        passengerSelectionPanelContainer: passengerSelectionMobileStyles.passengerSelectionPanelContainer,
        passengerSelectionHeaderContainer: passengerSelectionMobileStyles.passengerSelectionHeaderContainer,
        passengerSelectionHeaderIconButtonContainer: passengerSelectionMobileStyles.passengerSelectionHeaderIconButtonContainer,
        passengerSelectionHeaderTitle: passengerSelectionMobileStyles.passengerSelectionHeaderTitle,
        passengerSelectionHeaderButton: passengerSelectionMobileStyles.passengerSelectionHeaderButton,
        passengerSelectionTitle: passengerSelectionMobileStyles.passengerSelectionTitle,
        passengersQuantitySelectorContainer: passengerSelectionMobileStyles.passengersQuantitySelectorContainer,
        passengersQuantitySelectorButton: passengerSelectionMobileStyles.passengersQuantitySelectorButton,
        passengersQuantitySelectorButtonIcon: passengerSelectionMobileStyles.passengersQuantitySelectorButtonIcon,
        passengersApplyButtonContainer: passengerSelectionMobileStyles.passengersApplyButtonContainer,
        passengersCabinClassContainer: passengerSelectionMobileStyles.passengersCabinClassContainer,
        passengersApplyButton: passengerSelectionMobileStyles.passengersApplyButton,
        passengersEditButton: passengerSelectionMobileStyles.passengersEditButton
      },
      OriginSelection: {
        originSelectionPanelContainer: originSelectionMobileStyles.originSelectionPanelContainer,
        originSelectionHeaderTitle: originSelectionMobileStyles.originSelectionHeaderTitle,
        originSelectionHeaderButton: originSelectionMobileStyles.originSelectionHeaderButton,
        originSelectionTitle: originSelectionMobileStyles.originSelectionTitle,
        originSelectionApplyButton: originSelectionMobileStyles.originSelectionApplyButton,
        originSelectionCancelButton: originSelectionMobileStyles.originSelectionCancelButton,
        originSelectionApplyButtonContainer: originSelectionMobileStyles.originSelectionApplyButtonContainer
      },
      DestinationSelection: {
        destinationSelectionPanelContainer: destinationSelectionMobileStyles.destinationSelectionPanelContainer,
        destinationSelectionHeaderTitle: destinationSelectionMobileStyles.destinationSelectionHeaderTitle,
        destinationSelectionHeaderButton: destinationSelectionMobileStyles.destinationSelectionHeaderButton,
        destinationSelectionTitle: destinationSelectionMobileStyles.destinationSelectionTitle,
        destinationSelectionApplyButton: destinationSelectionMobileStyles.destinationSelectionApplyButton,
        destinationSelectionCancelButton: destinationSelectionMobileStyles.destinationSelectionCancelButton,
        destinationSelectionApplyButtonContainer: destinationSelectionMobileStyles.destinationSelectionApplyButtonContainer
      },
      CalendarSelection: {
        calendarSelectionPanelContainer: calendarSelectionMobileStyles.calendarSelectionPanelContainer,
        calendarSelectionApplyButton: calendarSelectionMobileStyles.calendarSelectionApplyButton,
        calendarSelectionCancelButton: calendarSelectionMobileStyles.calendarSelectionCancelButton,
        calendarSelectionInputsContainer: calendarSelectionMobileStyles.calendarSelectionInputsContainer,
        calendarSelectionApplyButtonContainer: calendarSelectionMobileStyles.calendarSelectionApplyButtonContainer,
        calendarSelectionPricesContainer: calendarSelectionMobileStyles.calendarSelectionPricesContainer
      },
      EditFlightSelection: {
        editFlightSelectionPanelContainer: editFlightSelectionMobileStyles.editFlightSelectionPanelContainer,
        editFlightSelectionHeaderContainer: editFlightSelectionMobileStyles.editFlightSelectionHeaderContainer,
        editFlightSelectionTitle: editFlightSelectionMobileStyles.editFlightSelectionTitle,
        editFlightSelectionInputsContainer: editFlightSelectionMobileStyles.editFlightSelectionInputsContainer,
        editFlightSelectionApplyButtonContainer: editFlightSelectionMobileStyles.editFlightSelectionApplyButtonContainer
      },
      GuestSelection: {
        guestSelectionPanelContainer: guestSelectionMobileStyles.guestSelectionPanelContainer,
        guestSelectionHeaderContainer: guestSelectionMobileStyles.guestSelectionHeaderContainer,
        guestSelectionHeaderTitle: guestSelectionMobileStyles.guestSelectionHeaderTitle,
        guestSelectionHeaderButton: guestSelectionMobileStyles.guestSelectionHeaderButton,
        guestSelectionTitle: guestSelectionMobileStyles.guestSelectionTitle,
        guestSelectionApplyButton: guestSelectionMobileStyles.guestSelectionApplyButton,
        guestSelectionCancelButton: guestSelectionMobileStyles.guestSelectionCancelButton,
        guestSelectionApplyButtonContainer: guestSelectionMobileStyles.guestSelectionApplyButtonContainer,
        guestSelectionOccupationInputsContainer: guestSelectionMobileStyles.guestSelectionOccupationInputsContainer
      },
      EditHotelSelection: {
        editHotelSelectionPanelContainer: editHotelSelectionMobileStyles.editHotelSelectionPanelContainer,
        editHotelSelectionHeaderContainer: editHotelSelectionMobileStyles.editHotelSelectionHeaderContainer,
        editHotelSelectionTitle: editHotelSelectionMobileStyles.editHotelSelectionTitle,
        editHotelSelectionApplyButtonContainer: editHotelSelectionMobileStyles.editHotelSelectionApplyButtonContainer,
        editHotelSelectionInputsContainer: editHotelSelectionMobileStyles.editHotelSelectionInputsContainer
      },
      EditCarSelection: {
        editCarSelectionPanelContainer: editCarSelectionMobileStyles.editCarSelectionPanelContainer,
        editCarSelectionHeaderContainer: editCarSelectionMobileStyles.editCarSelectionHeaderContainer,
        editCarSelectionTitle: editCarSelectionMobileStyles.editCarSelectionTitle,
        editCarSelectionApplyButtonContainer: editCarSelectionMobileStyles.editCarSelectionApplyButtonContainer,
        editCarSelectionInputsContainer: editCarSelectionMobileStyles.editCarSelectionInputsContainer
      },
      Autocomplete: {
        borderlessInputContainer: autocompleteMobileStyles.borderlessInputContainer,
        borderlessInput: autocompleteMobileStyles.borderlessInput,
        borderlessInputFocus: autocompleteMobileStyles.borderlessInputFocus,
        borderlessInputText: autocompleteMobileStyles.borderlessInputText,
        borderlessInputLabel: autocompleteMobileStyles.borderlessInputLabel,
        borderlessInputLabelSmall: autocompleteMobileStyles.borderlessInputLabelSmall,
        borderlessInputClearButton: autocompleteMobileStyles.borderlessInputClearButton,
        borderlessInputIcon: autocompleteMobileStyles.borderlessInputIcon,
        borderlessDropdown: autocompleteMobileStyles.borderlessDropdown,
        borderlessOption: autocompleteMobileStyles.borderlessOption,
        borderlessOptionTitle: autocompleteMobileStyles.borderlessOptionTitle,
        borderlessOptionSubtitle: autocompleteMobileStyles.borderlessOptionSubtitle
      }
    }
  },
  footers: {
    footerInterbank: {
      aboutContainerClassNames: footerInterbankStyles.aboutContainerClassNames,
      aboutInfoContainerClassNames: footerInterbankStyles.aboutInfoContainerClassNames,
      aboutInfoItemContainerClassNames: footerInterbankStyles.aboutInfoItemContainerClassNames,
      aboutInfoItemTextClassNames: footerInterbankStyles.aboutInfoItemTextClassNames,
      aboutInfoItemIconClassNames: footerInterbankStyles.aboutInfoItemIconClassNames,
      infoContainerClassNames: footerInterbankStyles.infoContainerClassNames,
      infoItemsContainerClassNames: footerInterbankStyles.infoItemsContainerClassNames,
      entityLogoContainerClassNames: footerInterbankStyles.entityLogoContainerClassNames,
      entityLogoClassNames: footerInterbankStyles.entityLogoClassNames,
      entityTextClassNames: footerInterbankStyles.entityTextClassNames,
      borderColorClassNames: footerInterbankStyles.borderColorClassNames,
      contactInfoContainerClassNames: footerInterbankStyles.contactInfoContainerClassNames,
      contacInfoTitleClassNames: footerInterbankStyles.contacInfoTitleClassNames,
      contacInfoTitleArrowClassNames: footerInterbankStyles.contacInfoTitleArrowClassNames,
      contacInfoSupportMessageClassNames: footerInterbankStyles.contacInfoSupportMessageClassNames,
      supportContactContainerClassNames: footerInterbankStyles.supportContactContainerClassNames,
      supportContactTextContainerClassNames: footerInterbankStyles.supportContactTextContainerClassNames,
      supportContactHeadsetIconClassNames: footerInterbankStyles.supportContactHeadsetIconClassNames,
      supportContactItemTextContainerClassNames: footerInterbankStyles.supportContactItemTextContainerClassNames,
      supportContactItemTitleClassNames: footerInterbankStyles.supportContactItemTitleClassNames,
      supportContactItemDescriptionClassNames: footerInterbankStyles.supportContactItemDescriptionClassNames,
      supportContactEmailIconClassNames: footerInterbankStyles.supportContactEmailIconClassNames,
      linksContainerClassNames: footerInterbankStyles.linksContainerClassNames,
      linksTitleClassNames: footerInterbankStyles.linksTitleClassNames,
      linkBookClassNames: footerInterbankStyles.linkBookClassNames,
      linkSocialClassNames: footerInterbankStyles.linkSocialClassNames,
      linksPolicysClassNames: footerInterbankStyles.linksPolicysClassNames,
      linksTermsClassNames: footerInterbankStyles.linksTermsClassNames,
      paymentMethodsContainerClassNames: footerInterbankStyles.paymentMethodsContainerClassNames,
      paymentMethodsTitleClassNames: footerInterbankStyles.paymentMethodsTitleClassNames,
      paymentMethodsImagesContainerClassNames: footerInterbankStyles.paymentMethodsImagesContainerClassNames,
      paymentMethodsImageVisaClassNames: footerInterbankStyles.paymentMethodsImageVisaClassNames,
      paymentMethodsImageAmericanExpressClassNames: footerInterbankStyles.paymentMethodsImageAmericanExpressClassNames,
      paymentMethodsImageBenefitClassNames: footerInterbankStyles.paymentMethodsImageBenefitClassNames
    }
  },
  landingGeneric: {
    polygonMask: {
      title: polygonMaskStyles.title,
      description: polygonMaskStyles.description,
      buttonContainer: polygonMaskStyles.buttonContainer,
      button: polygonMaskStyles.button,
      image: polygonMaskStyles.image,
      content: polygonMaskStyles.content,
      gradient: polygonMaskStyles.gradient
    },
    sectionOne: {
      templateOneContainer: sectionOneStyles.templateOneContainer,
      templateOneContent: sectionOneStyles.templateOneContent,
      templateOneTitle: sectionOneStyles.templateOneTitle,
      informationItemClasses: {
        container: sectionOneStyles.informationItemContainer,
        title: sectionOneStyles.informationItemTitle,
        description: sectionOneStyles.informationItemDescription
      }
    },
    sectionTwo: {
      templateTwoContainer: sectionTwoStyles.templateTwoContainer,
      templateTwoContent: sectionTwoStyles.templateTwoContent,
      templateTwoTitle: sectionTwoStyles.templateTwoTitle,
      informationItemClasses: {
        container: sectionTwoStyles.informationItemContainer,
        title: sectionTwoStyles.informationItemTitle,
        description: sectionTwoStyles.informationItemDescription
      }
    },
    sectionThree: {
      templateThreeContainer: sectionThreeStyles.templateThreeContainer,
      templateThreeContent: sectionThreeStyles.templateThreeContent,
      templateThreeTitle: sectionThreeStyles.templateThreeTitle,
      informationItemOneClasses: {
        container: sectionThreeStyles.informationItemOneContainer,
        title: sectionThreeStyles.informationItemOneTitle,
        description: sectionThreeStyles.informationItemOneDescription,
        content: sectionThreeStyles.informationItemOneContent
      },
      informationItemTwoClasses: {
        container: sectionThreeStyles.informationItemTwoContainer,
        title: sectionThreeStyles.informationItemTwoTitle,
        description: sectionThreeStyles.informationItemTwoDescription,
        content: sectionThreeStyles.informationItemTwoContent
      },
      informationItemThreeClasses: {
        container: sectionThreeStyles.informationItemThreeContainer,
        title: sectionThreeStyles.informationItemThreeTitle,
        description: sectionThreeStyles.informationItemThreeDescription,
        content: sectionThreeStyles.informationItemThreeContent
      }
    },
    button: {
      button: buttonStyles.button,
      buttonContainer: buttonStyles.buttonContainer
    }
  },
  landingClosed: {
    mainContainer: landingClosedStyles.mainContainer,
    contentContainer: landingClosedStyles.contentContainer,
    redirectingContainer: landingClosedStyles.redirectingContainer,
    exitContainer: landingClosedStyles.exitContainer
  }
};
export default classes;